/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
 !function (a, b, c, d) { function e(b, c) { this.settings = null, this.options = a.extend({}, e.Defaults, c), this.$element = a(b), this._handlers = {}, this._plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = [], this._breakpoint = null, this._width = null, this._items = [], this._clones = [], this._mergers = [], this._widths = [], this._invalidated = {}, this._pipe = [], this._drag = { time: null, target: null, pointer: null, stage: { start: null, current: null }, direction: null }, this._states = { current: {}, tags: { initializing: ["busy"], animating: ["busy"], dragging: ["interacting"] } }, a.each(["onResize", "onThrottledResize"], a.proxy(function (b, c) { this._handlers[c] = a.proxy(this[c], this) }, this)), a.each(e.Plugins, a.proxy(function (a, b) { this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this) }, this)), a.each(e.Workers, a.proxy(function (b, c) { this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) }) }, this)), this.setup(), this.initialize() } e.Defaults = { items: 3, loop: !1, center: !1, rewind: !1, checkVisibility: !0, mouseDrag: !0, touchDrag: !0, pullDrag: !0, freeDrag: !1, margin: 0, stagePadding: 0, merge: !1, mergeFit: !0, autoWidth: !1, startPosition: 0, rtl: !1, smartSpeed: 250, fluidSpeed: !1, dragEndSpeed: !1, responsive: {}, responsiveRefreshRate: 200, responsiveBaseElement: b, fallbackEasing: "swing", slideTransition: "", info: !1, nestedItemSelector: !1, itemElement: "div", stageElement: "div", refreshClass: "owl-refresh", loadedClass: "owl-loaded", loadingClass: "owl-loading", rtlClass: "owl-rtl", responsiveClass: "owl-responsive", dragClass: "owl-drag", itemClass: "owl-item", stageClass: "owl-stage", stageOuterClass: "owl-stage-outer", grabClass: "owl-grab" }, e.Width = { Default: "default", Inner: "inner", Outer: "outer" }, e.Type = { Event: "event", State: "state" }, e.Plugins = {}, e.Workers = [{ filter: ["width", "settings"], run: function () { this._width = this.$element.width() } }, { filter: ["width", "items", "settings"], run: function (a) { a.current = this._items && this._items[this.relative(this._current)] } }, { filter: ["items", "settings"], run: function () { this.$stage.children(".cloned").remove() } }, { filter: ["width", "items", "settings"], run: function (a) { var b = this.settings.margin || "", c = !this.settings.autoWidth, d = this.settings.rtl, e = { width: "auto", "margin-left": d ? b : "", "margin-right": d ? "" : b }; !c && this.$stage.children().css(e), a.css = e } }, { filter: ["width", "items", "settings"], run: function (a) { var b = (this.width() / this.settings.items).toFixed(3) - this.settings.margin, c = null, d = this._items.length, e = !this.settings.autoWidth, f = []; for (a.items = { merge: !1, width: b }; d--;)c = this._mergers[d], c = this.settings.mergeFit && Math.min(c, this.settings.items) || c, a.items.merge = c > 1 || a.items.merge, f[d] = e ? b * c : this._items[d].width(); this._widths = f } }, { filter: ["items", "settings"], run: function () { var b = [], c = this._items, d = this.settings, e = Math.max(2 * d.items, 4), f = 2 * Math.ceil(c.length / 2), g = d.loop && c.length ? d.rewind ? e : Math.max(e, f) : 0, h = "", i = ""; for (g /= 2; g > 0;)b.push(this.normalize(b.length / 2, !0)), h += c[b[b.length - 1]][0].outerHTML, b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)), i = c[b[b.length - 1]][0].outerHTML + i, g -= 1; this._clones = b, a(h).addClass("cloned").appendTo(this.$stage), a(i).addClass("cloned").prependTo(this.$stage) } }, { filter: ["width", "items", "settings"], run: function () { for (var a = this.settings.rtl ? 1 : -1, b = this._clones.length + this._items.length, c = -1, d = 0, e = 0, f = []; ++c < b;)d = f[c - 1] || 0, e = this._widths[this.relative(c)] + this.settings.margin, f.push(d + e * a); this._coordinates = f } }, { filter: ["width", "items", "settings"], run: function () { var a = this.settings.stagePadding, b = this._coordinates, c = { width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a, "padding-left": a || "", "padding-right": a || "" }; this.$stage.css(c) } }, { filter: ["width", "items", "settings"], run: function (a) { var b = this._coordinates.length, c = !this.settings.autoWidth, d = this.$stage.children(); if (c && a.items.merge) for (; b--;)a.css.width = this._widths[this.relative(b)], d.eq(b).css(a.css); else c && (a.css.width = a.items.width, d.css(a.css)) } }, { filter: ["items"], run: function () { this._coordinates.length < 1 && this.$stage.removeAttr("style") } }, { filter: ["width", "items", "settings"], run: function (a) { a.current = a.current ? this.$stage.children().index(a.current) : 0, a.current = Math.max(this.minimum(), Math.min(this.maximum(), a.current)), this.reset(a.current) } }, { filter: ["position"], run: function () { this.animate(this.coordinates(this._current)) } }, { filter: ["width", "position", "items", "settings"], run: function () { var a, b, c, d, e = this.settings.rtl ? 1 : -1, f = 2 * this.settings.stagePadding, g = this.coordinates(this.current()) + f, h = g + this.width() * e, i = []; for (c = 0, d = this._coordinates.length; c < d; c++)a = this._coordinates[c - 1] || 0, b = Math.abs(this._coordinates[c]) + f * e, (this.op(a, "<=", g) && this.op(a, ">", h) || this.op(b, "<", g) && this.op(b, ">", h)) && i.push(c); this.$stage.children(".active").removeClass("active"), this.$stage.children(":eq(" + i.join("), :eq(") + ")").addClass("active"), this.$stage.children(".center").removeClass("center"), this.settings.center && this.$stage.children().eq(this.current()).addClass("center") } }], e.prototype.initializeStage = function () { this.$stage = this.$element.find("." + this.settings.stageClass), this.$stage.length || (this.$element.addClass(this.options.loadingClass), this.$stage = a("<" + this.settings.stageElement + ">", { class: this.settings.stageClass }).wrap(a("<div/>", { class: this.settings.stageOuterClass })), this.$element.append(this.$stage.parent())) }, e.prototype.initializeItems = function () { var b = this.$element.find(".owl-item"); if (b.length) return this._items = b.get().map(function (b) { return a(b) }), this._mergers = this._items.map(function () { return 1 }), void this.refresh(); this.replace(this.$element.children().not(this.$stage.parent())), this.isVisible() ? this.refresh() : this.invalidate("width"), this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass) }, e.prototype.initialize = function () { if (this.enter("initializing"), this.trigger("initialize"), this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl), this.settings.autoWidth && !this.is("pre-loading")) { var a, b, c; a = this.$element.find("img"), b = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d, c = this.$element.children(b).width(), a.length && c <= 0 && this.preloadAutoWidthImages(a) } this.initializeStage(), this.initializeItems(), this.registerEventHandlers(), this.leave("initializing"), this.trigger("initialized") }, e.prototype.isVisible = function () { return !this.settings.checkVisibility || this.$element.is(":visible") }, e.prototype.setup = function () { var b = this.viewport(), c = this.options.responsive, d = -1, e = null; c ? (a.each(c, function (a) { a <= b && a > d && (d = Number(a)) }), e = a.extend({}, this.options, c[d]), "function" == typeof e.stagePadding && (e.stagePadding = e.stagePadding()), delete e.responsive, e.responsiveClass && this.$element.attr("class", this.$element.attr("class").replace(new RegExp("(" + this.options.responsiveClass + "-)\\S+\\s", "g"), "$1" + d))) : e = a.extend({}, this.options), this.trigger("change", { property: { name: "settings", value: e } }), this._breakpoint = d, this.settings = e, this.invalidate("settings"), this.trigger("changed", { property: { name: "settings", value: this.settings } }) }, e.prototype.optionsLogic = function () { this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1) }, e.prototype.prepare = function (b) { var c = this.trigger("prepare", { content: b }); return c.data || (c.data = a("<" + this.settings.itemElement + "/>").addClass(this.options.itemClass).append(b)), this.trigger("prepared", { content: c.data }), c.data }, e.prototype.update = function () { for (var b = 0, c = this._pipe.length, d = a.proxy(function (a) { return this[a] }, this._invalidated), e = {}; b < c;)(this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) && this._pipe[b].run(e), b++; this._invalidated = {}, !this.is("valid") && this.enter("valid") }, e.prototype.width = function (a) { switch (a = a || e.Width.Default) { case e.Width.Inner: case e.Width.Outer: return this._width; default: return this._width - 2 * this.settings.stagePadding + this.settings.margin } }, e.prototype.refresh = function () { this.enter("refreshing"), this.trigger("refresh"), this.setup(), this.optionsLogic(), this.$element.addClass(this.options.refreshClass), this.update(), this.$element.removeClass(this.options.refreshClass), this.leave("refreshing"), this.trigger("refreshed") }, e.prototype.onThrottledResize = function () { b.clearTimeout(this.resizeTimer), this.resizeTimer = b.setTimeout(this._handlers.onResize, this.settings.responsiveRefreshRate) }, e.prototype.onResize = function () { return !!this._items.length && (this._width !== this.$element.width() && (!!this.isVisible() && (this.enter("resizing"), this.trigger("resize").isDefaultPrevented() ? (this.leave("resizing"), !1) : (this.invalidate("width"), this.refresh(), this.leave("resizing"), void this.trigger("resized"))))) }, e.prototype.registerEventHandlers = function () { a.support.transition && this.$stage.on(a.support.transition.end + ".owl.core", a.proxy(this.onTransitionEnd, this)), !1 !== this.settings.responsive && this.on(b, "resize", this._handlers.onThrottledResize), this.settings.mouseDrag && (this.$element.addClass(this.options.dragClass), this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("dragstart.owl.core selectstart.owl.core", function () { return !1 })), this.settings.touchDrag && (this.$stage.on("touchstart.owl.core", a.proxy(this.onDragStart, this)), this.$stage.on("touchcancel.owl.core", a.proxy(this.onDragEnd, this))) }, e.prototype.onDragStart = function (b) { var d = null; 3 !== b.which && (a.support.transform ? (d = this.$stage.css("transform").replace(/.*\(|\)| /g, "").split(","), d = { x: d[16 === d.length ? 12 : 4], y: d[16 === d.length ? 13 : 5] }) : (d = this.$stage.position(), d = { x: this.settings.rtl ? d.left + this.$stage.width() - this.width() + this.settings.margin : d.left, y: d.top }), this.is("animating") && (a.support.transform ? this.animate(d.x) : this.$stage.stop(), this.invalidate("position")), this.$element.toggleClass(this.options.grabClass, "mousedown" === b.type), this.speed(0), this._drag.time = (new Date).getTime(), this._drag.target = a(b.target), this._drag.stage.start = d, this._drag.stage.current = d, this._drag.pointer = this.pointer(b), a(c).on("mouseup.owl.core touchend.owl.core", a.proxy(this.onDragEnd, this)), a(c).one("mousemove.owl.core touchmove.owl.core", a.proxy(function (b) { var d = this.difference(this._drag.pointer, this.pointer(b)); a(c).on("mousemove.owl.core touchmove.owl.core", a.proxy(this.onDragMove, this)), Math.abs(d.x) < Math.abs(d.y) && this.is("valid") || (b.preventDefault(), this.enter("dragging"), this.trigger("drag")) }, this))) }, e.prototype.onDragMove = function (a) { var b = null, c = null, d = null, e = this.difference(this._drag.pointer, this.pointer(a)), f = this.difference(this._drag.stage.start, e); this.is("dragging") && (a.preventDefault(), this.settings.loop ? (b = this.coordinates(this.minimum()), c = this.coordinates(this.maximum() + 1) - b, f.x = ((f.x - b) % c + c) % c + b) : (b = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), c = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), d = this.settings.pullDrag ? -1 * e.x / 5 : 0, f.x = Math.max(Math.min(f.x, b + d), c + d)), this._drag.stage.current = f, this.animate(f.x)) }, e.prototype.onDragEnd = function (b) { var d = this.difference(this._drag.pointer, this.pointer(b)), e = this._drag.stage.current, f = d.x > 0 ^ this.settings.rtl ? "left" : "right"; a(c).off(".owl.core"), this.$element.removeClass(this.options.grabClass), (0 !== d.x && this.is("dragging") || !this.is("valid")) && (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)), this.invalidate("position"), this.update(), this._drag.direction = f, (Math.abs(d.x) > 3 || (new Date).getTime() - this._drag.time > 300) && this._drag.target.one("click.owl.core", function () { return !1 })), this.is("dragging") && (this.leave("dragging"), this.trigger("dragged")) }, e.prototype.closest = function (b, c) { var e = -1, f = 30, g = this.width(), h = this.coordinates(); return this.settings.freeDrag || a.each(h, a.proxy(function (a, i) { return "left" === c && b > i - f && b < i + f ? e = a : "right" === c && b > i - g - f && b < i - g + f ? e = a + 1 : this.op(b, "<", i) && this.op(b, ">", h[a + 1] !== d ? h[a + 1] : i - g) && (e = "left" === c ? a + 1 : a), -1 === e }, this)), this.settings.loop || (this.op(b, ">", h[this.minimum()]) ? e = b = this.minimum() : this.op(b, "<", h[this.maximum()]) && (e = b = this.maximum())), e }, e.prototype.animate = function (b) { var c = this.speed() > 0; this.is("animating") && this.onTransitionEnd(), c && (this.enter("animating"), this.trigger("translate")), a.support.transform3d && a.support.transition ? this.$stage.css({ transform: "translate3d(" + b + "px,0px,0px)", transition: this.speed() / 1e3 + "s" + (this.settings.slideTransition ? " " + this.settings.slideTransition : "") }) : c ? this.$stage.animate({ left: b + "px" }, this.speed(), this.settings.fallbackEasing, a.proxy(this.onTransitionEnd, this)) : this.$stage.css({ left: b + "px" }) }, e.prototype.is = function (a) { return this._states.current[a] && this._states.current[a] > 0 }, e.prototype.current = function (a) { if (a === d) return this._current; if (0 === this._items.length) return d; if (a = this.normalize(a), this._current !== a) { var b = this.trigger("change", { property: { name: "position", value: a } }); b.data !== d && (a = this.normalize(b.data)), this._current = a, this.invalidate("position"), this.trigger("changed", { property: { name: "position", value: this._current } }) } return this._current }, e.prototype.invalidate = function (b) { return "string" === a.type(b) && (this._invalidated[b] = !0, this.is("valid") && this.leave("valid")), a.map(this._invalidated, function (a, b) { return b }) }, e.prototype.reset = function (a) { (a = this.normalize(a)) !== d && (this._speed = 0, this._current = a, this.suppress(["translate", "translated"]), this.animate(this.coordinates(a)), this.release(["translate", "translated"])) }, e.prototype.normalize = function (a, b) { var c = this._items.length, e = b ? 0 : this._clones.length; return !this.isNumeric(a) || c < 1 ? a = d : (a < 0 || a >= c + e) && (a = ((a - e / 2) % c + c) % c + e / 2), a }, e.prototype.relative = function (a) { return a -= this._clones.length / 2, this.normalize(a, !0) }, e.prototype.maximum = function (a) { var b, c, d, e = this.settings, f = this._coordinates.length; if (e.loop) f = this._clones.length / 2 + this._items.length - 1; else if (e.autoWidth || e.merge) { if (b = this._items.length) for (c = this._items[--b].width(), d = this.$element.width(); b-- && !((c += this._items[b].width() + this.settings.margin) > d);); f = b + 1 } else f = e.center ? this._items.length - 1 : this._items.length - e.items; return a && (f -= this._clones.length / 2), Math.max(f, 0) }, e.prototype.minimum = function (a) { return a ? 0 : this._clones.length / 2 }, e.prototype.items = function (a) { return a === d ? this._items.slice() : (a = this.normalize(a, !0), this._items[a]) }, e.prototype.mergers = function (a) { return a === d ? this._mergers.slice() : (a = this.normalize(a, !0), this._mergers[a]) }, e.prototype.clones = function (b) { var c = this._clones.length / 2, e = c + this._items.length, f = function (a) { return a % 2 == 0 ? e + a / 2 : c - (a + 1) / 2 }; return b === d ? a.map(this._clones, function (a, b) { return f(b) }) : a.map(this._clones, function (a, c) { return a === b ? f(c) : null }) }, e.prototype.speed = function (a) { return a !== d && (this._speed = a), this._speed }, e.prototype.coordinates = function (b) { var c, e = 1, f = b - 1; return b === d ? a.map(this._coordinates, a.proxy(function (a, b) { return this.coordinates(b) }, this)) : (this.settings.center ? (this.settings.rtl && (e = -1, f = b + 1), c = this._coordinates[b], c += (this.width() - c + (this._coordinates[f] || 0)) / 2 * e) : c = this._coordinates[f] || 0, c = Math.ceil(c)) }, e.prototype.duration = function (a, b, c) { return 0 === c ? 0 : Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed) }, e.prototype.to = function (a, b) { var c = this.current(), d = null, e = a - this.relative(c), f = (e > 0) - (e < 0), g = this._items.length, h = this.minimum(), i = this.maximum(); this.settings.loop ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += -1 * f * g), a = c + e, (d = ((a - h) % g + g) % g + h) !== a && d - e <= i && d - e > 0 && (c = d - e, a = d, this.reset(c))) : this.settings.rewind ? (i += 1, a = (a % i + i) % i) : a = Math.max(h, Math.min(i, a)), this.speed(this.duration(c, a, b)), this.current(a), this.isVisible() && this.update() }, e.prototype.next = function (a) { a = a || !1, this.to(this.relative(this.current()) + 1, a) }, e.prototype.prev = function (a) { a = a || !1, this.to(this.relative(this.current()) - 1, a) }, e.prototype.onTransitionEnd = function (a) { if (a !== d && (a.stopPropagation(), (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))) return !1; this.leave("animating"), this.trigger("translated") }, e.prototype.viewport = function () { var d; return this.options.responsiveBaseElement !== b ? d = a(this.options.responsiveBaseElement).width() : b.innerWidth ? d = b.innerWidth : c.documentElement && c.documentElement.clientWidth ? d = c.documentElement.clientWidth : console.warn("Can not detect viewport width."), d }, e.prototype.replace = function (b) { this.$stage.empty(), this._items = [], b && (b = b instanceof jQuery ? b : a(b)), this.settings.nestedItemSelector && (b = b.find("." + this.settings.nestedItemSelector)), b.filter(function () { return 1 === this.nodeType }).each(a.proxy(function (a, b) { b = this.prepare(b), this.$stage.append(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1) }, this)), this.reset(this.isNumeric(this.settings.startPosition) ? this.settings.startPosition : 0), this.invalidate("items") }, e.prototype.add = function (b, c) { var e = this.relative(this._current); c = c === d ? this._items.length : this.normalize(c, !0), b = b instanceof jQuery ? b : a(b), this.trigger("add", { content: b, position: c }), b = this.prepare(b), 0 === this._items.length || c === this._items.length ? (0 === this._items.length && this.$stage.append(b), 0 !== this._items.length && this._items[c - 1].after(b), this._items.push(b), this._mergers.push(1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)) : (this._items[c].before(b), this._items.splice(c, 0, b), this._mergers.splice(c, 0, 1 * b.find("[data-merge]").addBack("[data-merge]").attr("data-merge") || 1)), this._items[e] && this.reset(this._items[e].index()), this.invalidate("items"), this.trigger("added", { content: b, position: c }) }, e.prototype.remove = function (a) { (a = this.normalize(a, !0)) !== d && (this.trigger("remove", { content: this._items[a], position: a }), this._items[a].remove(), this._items.splice(a, 1), this._mergers.splice(a, 1), this.invalidate("items"), this.trigger("removed", { content: null, position: a })) }, e.prototype.preloadAutoWidthImages = function (b) { b.each(a.proxy(function (b, c) { this.enter("pre-loading"), c = a(c), a(new Image).one("load", a.proxy(function (a) { c.attr("src", a.target.src), c.css("opacity", 1), this.leave("pre-loading"), !this.is("pre-loading") && !this.is("initializing") && this.refresh() }, this)).attr("src", c.attr("src") || c.attr("data-src") || c.attr("data-src-retina")) }, this)) }, e.prototype.destroy = function () { this.$element.off(".owl.core"), this.$stage.off(".owl.core"), a(c).off(".owl.core"), !1 !== this.settings.responsive && (b.clearTimeout(this.resizeTimer), this.off(b, "resize", this._handlers.onThrottledResize)); for (var d in this._plugins) this._plugins[d].destroy(); this.$stage.children(".cloned").remove(), this.$stage.unwrap(), this.$stage.children().contents().unwrap(), this.$stage.children().unwrap(), this.$stage.remove(), this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class", this.$element.attr("class").replace(new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"), "")).removeData("owl.carousel") }, e.prototype.op = function (a, b, c) { var d = this.settings.rtl; switch (b) { case "<": return d ? a > c : a < c; case ">": return d ? a < c : a > c; case ">=": return d ? a <= c : a >= c; case "<=": return d ? a >= c : a <= c } }, e.prototype.on = function (a, b, c, d) { a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c) }, e.prototype.off = function (a, b, c, d) { a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c) }, e.prototype.trigger = function (b, c, d, f, g) { var h = { item: { count: this._items.length, index: this.current() } }, i = a.camelCase(a.grep(["on", b, d], function (a) { return a }).join("-").toLowerCase()), j = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({ relatedTarget: this }, h, c)); return this._supress[b] || (a.each(this._plugins, function (a, b) { b.onTrigger && b.onTrigger(j) }), this.register({ type: e.Type.Event, name: b }), this.$element.trigger(j), this.settings && "function" == typeof this.settings[i] && this.settings[i].call(this, j)), j }, e.prototype.enter = function (b) { a.each([b].concat(this._states.tags[b] || []), a.proxy(function (a, b) { this._states.current[b] === d && (this._states.current[b] = 0), this._states.current[b]++ }, this)) }, e.prototype.leave = function (b) { a.each([b].concat(this._states.tags[b] || []), a.proxy(function (a, b) { this._states.current[b]-- }, this)) }, e.prototype.register = function (b) { if (b.type === e.Type.Event) { if (a.event.special[b.name] || (a.event.special[b.name] = {}), !a.event.special[b.name].owl) { var c = a.event.special[b.name]._default; a.event.special[b.name]._default = function (a) { return !c || !c.apply || a.namespace && -1 !== a.namespace.indexOf("owl") ? a.namespace && a.namespace.indexOf("owl") > -1 : c.apply(this, arguments) }, a.event.special[b.name].owl = !0 } } else b.type === e.Type.State && (this._states.tags[b.name] ? this._states.tags[b.name] = this._states.tags[b.name].concat(b.tags) : this._states.tags[b.name] = b.tags, this._states.tags[b.name] = a.grep(this._states.tags[b.name], a.proxy(function (c, d) { return a.inArray(c, this._states.tags[b.name]) === d }, this))) }, e.prototype.suppress = function (b) { a.each(b, a.proxy(function (a, b) { this._supress[b] = !0 }, this)) }, e.prototype.release = function (b) { a.each(b, a.proxy(function (a, b) { delete this._supress[b] }, this)) }, e.prototype.pointer = function (a) { var c = { x: null, y: null }; return a = a.originalEvent || a || b.event, a = a.touches && a.touches.length ? a.touches[0] : a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : a, a.pageX ? (c.x = a.pageX, c.y = a.pageY) : (c.x = a.clientX, c.y = a.clientY), c }, e.prototype.isNumeric = function (a) { return !isNaN(parseFloat(a)) }, e.prototype.difference = function (a, b) { return { x: a.x - b.x, y: a.y - b.y } }, a.fn.owlCarousel = function (b) { var c = Array.prototype.slice.call(arguments, 1); return this.each(function () { var d = a(this), f = d.data("owl.carousel"); f || (f = new e(this, "object" == typeof b && b), d.data("owl.carousel", f), a.each(["next", "prev", "to", "destroy", "refresh", "replace", "add", "remove"], function (b, c) { f.register({ type: e.Type.Event, name: c }), f.$element.on(c + ".owl.carousel.core", a.proxy(function (a) { a.namespace && a.relatedTarget !== this && (this.suppress([c]), f[c].apply(this, [].slice.call(arguments, 1)), this.release([c])) }, f)) })), "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c) }) }, a.fn.owlCarousel.Constructor = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { var e = function (b) { this._core = b, this._interval = null, this._visible = null, this._handlers = { "initialized.owl.carousel": a.proxy(function (a) { a.namespace && this._core.settings.autoRefresh && this.watch() }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers) }; e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }, e.prototype.watch = function () { this._interval || (this._visible = this._core.isVisible(), this._interval = b.setInterval(a.proxy(this.refresh, this), this._core.settings.autoRefreshInterval)) }, e.prototype.refresh = function () { this._core.isVisible() !== this._visible && (this._visible = !this._visible, this._core.$element.toggleClass("owl-hidden", !this._visible), this._visible && this._core.invalidate("width") && this._core.refresh()) }, e.prototype.destroy = function () { var a, c; b.clearInterval(this._interval); for (a in this._handlers) this._core.$element.off(a, this._handlers[a]); for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null) }, a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { var e = function (b) { this._core = b, this._loaded = [], this._handlers = { "initialized.owl.carousel change.owl.carousel resized.owl.carousel": a.proxy(function (b) { if (b.namespace && this._core.settings && this._core.settings.lazyLoad && (b.property && "position" == b.property.name || "initialized" == b.type)) { var c = this._core.settings, e = c.center && Math.ceil(c.items / 2) || c.items, f = c.center && -1 * e || 0, g = (b.property && b.property.value !== d ? b.property.value : this._core.current()) + f, h = this._core.clones().length, i = a.proxy(function (a, b) { this.load(b) }, this); for (c.lazyLoadEager > 0 && (e += c.lazyLoadEager, c.loop && (g -= c.lazyLoadEager, e++)); f++ < e;)this.load(h / 2 + this._core.relative(g)), h && a.each(this._core.clones(this._core.relative(g)), i), g++ } }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers) }; e.Defaults = { lazyLoad: !1, lazyLoadEager: 0 }, e.prototype.load = function (c) { var d = this._core.$stage.children().eq(c), e = d && d.find(".owl-lazy"); !e || a.inArray(d.get(0), this._loaded) > -1 || (e.each(a.proxy(function (c, d) { var e, f = a(d), g = b.devicePixelRatio > 1 && f.attr("data-src-retina") || f.attr("data-src") || f.attr("data-srcset"); this._core.trigger("load", { element: f, url: g }, "lazy"), f.is("img") ? f.one("load.owl.lazy", a.proxy(function () { f.css("opacity", 1), this._core.trigger("loaded", { element: f, url: g }, "lazy") }, this)).attr("src", g) : f.is("source") ? f.one("load.owl.lazy", a.proxy(function () { this._core.trigger("loaded", { element: f, url: g }, "lazy") }, this)).attr("srcset", g) : (e = new Image, e.onload = a.proxy(function () { f.css({ "background-image": 'url("' + g + '")', opacity: "1" }), this._core.trigger("loaded", { element: f, url: g }, "lazy") }, this), e.src = g) }, this)), this._loaded.push(d.get(0))) }, e.prototype.destroy = function () { var a, b; for (a in this.handlers) this._core.$element.off(a, this.handlers[a]); for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null) }, a.fn.owlCarousel.Constructor.Plugins.Lazy = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { var e = function (c) { this._core = c, this._previousHeight = null, this._handlers = { "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (a) { a.namespace && this._core.settings.autoHeight && this.update() }, this), "changed.owl.carousel": a.proxy(function (a) { a.namespace && this._core.settings.autoHeight && "position" === a.property.name && this.update() }, this), "loaded.owl.lazy": a.proxy(function (a) { a.namespace && this._core.settings.autoHeight && a.element.closest("." + this._core.settings.itemClass).index() === this._core.current() && this.update() }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers), this._intervalId = null; var d = this; a(b).on("load", function () { d._core.settings.autoHeight && d.update() }), a(b).resize(function () { d._core.settings.autoHeight && (null != d._intervalId && clearTimeout(d._intervalId), d._intervalId = setTimeout(function () { d.update() }, 250)) }) }; e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }, e.prototype.update = function () { var b = this._core._current, c = b + this._core.settings.items, d = this._core.settings.lazyLoad, e = this._core.$stage.children().toArray().slice(b, c), f = [], g = 0; a.each(e, function (b, c) { f.push(a(c).height()) }), g = Math.max.apply(null, f), g <= 1 && d && this._previousHeight && (g = this._previousHeight), this._previousHeight = g, this._core.$stage.parent().height(g).addClass(this._core.settings.autoHeightClass) }, e.prototype.destroy = function () { var a, b; for (a in this._handlers) this._core.$element.off(a, this._handlers[a]); for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null) }, a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { var e = function (b) { this._core = b, this._videos = {}, this._playing = null, this._handlers = { "initialized.owl.carousel": a.proxy(function (a) { a.namespace && this._core.register({ type: "state", name: "playing", tags: ["interacting"] }) }, this), "resize.owl.carousel": a.proxy(function (a) { a.namespace && this._core.settings.video && this.isInFullScreen() && a.preventDefault() }, this), "refreshed.owl.carousel": a.proxy(function (a) { a.namespace && this._core.is("resizing") && this._core.$stage.find(".cloned .owl-video-frame").remove() }, this), "changed.owl.carousel": a.proxy(function (a) { a.namespace && "position" === a.property.name && this._playing && this.stop() }, this), "prepared.owl.carousel": a.proxy(function (b) { if (b.namespace) { var c = a(b.content).find(".owl-video"); c.length && (c.css("display", "none"), this.fetch(c, a(b.content))) } }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this._core.$element.on(this._handlers), this._core.$element.on("click.owl.video", ".owl-video-play-icon", a.proxy(function (a) { this.play(a) }, this)) }; e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }, e.prototype.fetch = function (a, b) { var c = function () { return a.attr("data-vimeo-id") ? "vimeo" : a.attr("data-vzaar-id") ? "vzaar" : "youtube" }(), d = a.attr("data-vimeo-id") || a.attr("data-youtube-id") || a.attr("data-vzaar-id"), e = a.attr("data-width") || this._core.settings.videoWidth, f = a.attr("data-height") || this._core.settings.videoHeight, g = a.attr("href"); if (!g) throw new Error("Missing video URL."); if (d = g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com|be\-nocookie\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), d[3].indexOf("youtu") > -1) c = "youtube"; else if (d[3].indexOf("vimeo") > -1) c = "vimeo"; else { if (!(d[3].indexOf("vzaar") > -1)) throw new Error("Video URL not supported."); c = "vzaar" } d = d[6], this._videos[g] = { type: c, id: d, width: e, height: f }, b.attr("data-video", g), this.thumbnail(a, this._videos[g]) }, e.prototype.thumbnail = function (b, c) { var d, e, f, g = c.width && c.height ? "width:" + c.width + "px;height:" + c.height + "px;" : "", h = b.find("img"), i = "src", j = "", k = this._core.settings, l = function (c) { e = '<div class="owl-video-play-icon"></div>', d = k.lazyLoad ? a("<div/>", { class: "owl-video-tn " + j, srcType: c }) : a("<div/>", { class: "owl-video-tn", style: "opacity:1;background-image:url(" + c + ")" }), b.after(d), b.after(e) }; if (b.wrap(a("<div/>", { class: "owl-video-wrapper", style: g })), this._core.settings.lazyLoad && (i = "data-src", j = "owl-lazy"), h.length) return l(h.attr(i)), h.remove(), !1; "youtube" === c.type ? (f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg", l(f)) : "vimeo" === c.type ? a.ajax({ type: "GET", url: "//vimeo.com/api/v2/video/" + c.id + ".json", jsonp: "callback", dataType: "jsonp", success: function (a) { f = a[0].thumbnail_large, l(f) } }) : "vzaar" === c.type && a.ajax({ type: "GET", url: "//vzaar.com/api/videos/" + c.id + ".json", jsonp: "callback", dataType: "jsonp", success: function (a) { f = a.framegrab_url, l(f) } }) }, e.prototype.stop = function () { this._core.trigger("stop", null, "video"), this._playing.find(".owl-video-frame").remove(), this._playing.removeClass("owl-video-playing"), this._playing = null, this._core.leave("playing"), this._core.trigger("stopped", null, "video") }, e.prototype.play = function (b) { var c, d = a(b.target), e = d.closest("." + this._core.settings.itemClass), f = this._videos[e.attr("data-video")], g = f.width || "100%", h = f.height || this._core.$stage.height(); this._playing || (this._core.enter("playing"), this._core.trigger("play", null, "video"), e = this._core.items(this._core.relative(e.index())), this._core.reset(e.index()), c = a('<iframe frameborder="0" allowfullscreen mozallowfullscreen webkitAllowFullScreen ></iframe>'), c.attr("height", h), c.attr("width", g), "youtube" === f.type ? c.attr("src", "//www.youtube.com/embed/" + f.id + "?autoplay=1&rel=0&v=" + f.id) : "vimeo" === f.type ? c.attr("src", "//player.vimeo.com/video/" + f.id + "?autoplay=1") : "vzaar" === f.type && c.attr("src", "//view.vzaar.com/" + f.id + "/player?autoplay=true"), a(c).wrap('<div class="owl-video-frame" />').insertAfter(e.find(".owl-video")), this._playing = e.addClass("owl-video-playing")) }, e.prototype.isInFullScreen = function () { var b = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement; return b && a(b).parent().hasClass("owl-video-frame") }, e.prototype.destroy = function () { var a, b; this._core.$element.off("click.owl.video"); for (a in this._handlers) this._core.$element.off(a, this._handlers[a]); for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null) }, a.fn.owlCarousel.Constructor.Plugins.Video = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) {
  var e = function (b) { this.core = b, this.core.options = a.extend({}, e.Defaults, this.core.options), this.swapping = !0, this.previous = d, this.next = d, this.handlers = { "change.owl.carousel": a.proxy(function (a) { a.namespace && "position" == a.property.name && (this.previous = this.core.current(), this.next = a.property.value) }, this), "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function (a) { a.namespace && (this.swapping = "translated" == a.type) }, this), "translate.owl.carousel": a.proxy(function (a) { a.namespace && this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap() }, this) }, this.core.$element.on(this.handlers) }; e.Defaults = {
    animateOut: !1,
    animateIn: !1
  }, e.prototype.swap = function () { if (1 === this.core.settings.items && a.support.animation && a.support.transition) { this.core.speed(0); var b, c = a.proxy(this.clear, this), d = this.core.$stage.children().eq(this.previous), e = this.core.$stage.children().eq(this.next), f = this.core.settings.animateIn, g = this.core.settings.animateOut; this.core.current() !== this.previous && (g && (b = this.core.coordinates(this.previous) - this.core.coordinates(this.next), d.one(a.support.animation.end, c).css({ left: b + "px" }).addClass("animated owl-animated-out").addClass(g)), f && e.one(a.support.animation.end, c).addClass("animated owl-animated-in").addClass(f)) } }, e.prototype.clear = function (b) { a(b.target).css({ left: "" }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.onTransitionEnd() }, e.prototype.destroy = function () { var a, b; for (a in this.handlers) this.core.$element.off(a, this.handlers[a]); for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null) }, a.fn.owlCarousel.Constructor.Plugins.Animate = e
}(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { var e = function (b) { this._core = b, this._call = null, this._time = 0, this._timeout = 0, this._paused = !0, this._handlers = { "changed.owl.carousel": a.proxy(function (a) { a.namespace && "settings" === a.property.name ? this._core.settings.autoplay ? this.play() : this.stop() : a.namespace && "position" === a.property.name && this._paused && (this._time = 0) }, this), "initialized.owl.carousel": a.proxy(function (a) { a.namespace && this._core.settings.autoplay && this.play() }, this), "play.owl.autoplay": a.proxy(function (a, b, c) { a.namespace && this.play(b, c) }, this), "stop.owl.autoplay": a.proxy(function (a) { a.namespace && this.stop() }, this), "mouseover.owl.autoplay": a.proxy(function () { this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause() }, this), "mouseleave.owl.autoplay": a.proxy(function () { this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.play() }, this), "touchstart.owl.core": a.proxy(function () { this._core.settings.autoplayHoverPause && this._core.is("rotating") && this.pause() }, this), "touchend.owl.core": a.proxy(function () { this._core.settings.autoplayHoverPause && this.play() }, this) }, this._core.$element.on(this._handlers), this._core.options = a.extend({}, e.Defaults, this._core.options) }; e.Defaults = { autoplay: !1, autoplayTimeout: 5e3, autoplayHoverPause: !1, autoplaySpeed: !1 }, e.prototype._next = function (d) { this._call = b.setTimeout(a.proxy(this._next, this, d), this._timeout * (Math.round(this.read() / this._timeout) + 1) - this.read()), this._core.is("interacting") || c.hidden || this._core.next(d || this._core.settings.autoplaySpeed) }, e.prototype.read = function () { return (new Date).getTime() - this._time }, e.prototype.play = function (c, d) { var e; this._core.is("rotating") || this._core.enter("rotating"), c = c || this._core.settings.autoplayTimeout, e = Math.min(this._time % (this._timeout || c), c), this._paused ? (this._time = this.read(), this._paused = !1) : b.clearTimeout(this._call), this._time += this.read() % c - e, this._timeout = c, this._call = b.setTimeout(a.proxy(this._next, this, d), c - e) }, e.prototype.stop = function () { this._core.is("rotating") && (this._time = 0, this._paused = !0, b.clearTimeout(this._call), this._core.leave("rotating")) }, e.prototype.pause = function () { this._core.is("rotating") && !this._paused && (this._time = this.read(), this._paused = !0, b.clearTimeout(this._call)) }, e.prototype.destroy = function () { var a, b; this.stop(); for (a in this._handlers) this._core.$element.off(a, this._handlers[a]); for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null) }, a.fn.owlCarousel.Constructor.Plugins.autoplay = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { "use strict"; var e = function (b) { this._core = b, this._initialized = !1, this._pages = [], this._controls = {}, this._templates = [], this.$element = this._core.$element, this._overrides = { next: this._core.next, prev: this._core.prev, to: this._core.to }, this._handlers = { "prepared.owl.carousel": a.proxy(function (b) { b.namespace && this._core.settings.dotsData && this._templates.push('<div class="' + this._core.settings.dotClass + '">' + a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot") + "</div>") }, this), "added.owl.carousel": a.proxy(function (a) { a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 0, this._templates.pop()) }, this), "remove.owl.carousel": a.proxy(function (a) { a.namespace && this._core.settings.dotsData && this._templates.splice(a.position, 1) }, this), "changed.owl.carousel": a.proxy(function (a) { a.namespace && "position" == a.property.name && this.draw() }, this), "initialized.owl.carousel": a.proxy(function (a) { a.namespace && !this._initialized && (this._core.trigger("initialize", null, "navigation"), this.initialize(), this.update(), this.draw(), this._initialized = !0, this._core.trigger("initialized", null, "navigation")) }, this), "refreshed.owl.carousel": a.proxy(function (a) { a.namespace && this._initialized && (this._core.trigger("refresh", null, "navigation"), this.update(), this.draw(), this._core.trigger("refreshed", null, "navigation")) }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers) }; e.Defaults = { nav: !1, navText: ['<span aria-label="Previous">&#x2039;</span>', '<span aria-label="Next">&#x203a;</span>'], navSpeed: !1, navElement: 'button type="button" role="presentation"', navContainer: !1, navContainerClass: "owl-nav", navClass: ["owl-prev", "owl-next"], slideBy: 1, dotClass: "owl-dot", dotsClass: "owl-dots", dots: !0, dotsEach: !1, dotsData: !1, dotsSpeed: !1, dotsContainer: !1 }, e.prototype.initialize = function () { var b, c = this._core.settings; this._controls.$relative = (c.navContainer ? a(c.navContainer) : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"), this._controls.$previous = a("<" + c.navElement + ">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click", a.proxy(function (a) { this.prev(c.navSpeed) }, this)), this._controls.$next = a("<" + c.navElement + ">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click", a.proxy(function (a) { this.next(c.navSpeed) }, this)), c.dotsData || (this._templates = [a('<button role="button">').addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]), this._controls.$absolute = (c.dotsContainer ? a(c.dotsContainer) : a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"), this._controls.$absolute.on("click", "button", a.proxy(function (b) { var d = a(b.target).parent().is(this._controls.$absolute) ? a(b.target).index() : a(b.target).parent().index(); b.preventDefault(), this.to(d, c.dotsSpeed) }, this)); for (b in this._overrides) this._core[b] = a.proxy(this[b], this) }, e.prototype.destroy = function () { var a, b, c, d, e; e = this._core.settings; for (a in this._handlers) this.$element.off(a, this._handlers[a]); for (b in this._controls) "$relative" === b && e.navContainer ? this._controls[b].html("") : this._controls[b].remove(); for (d in this.overides) this._core[d] = this._overrides[d]; for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null) }, e.prototype.update = function () { var a, b, c, d = this._core.clones().length / 2, e = d + this._core.items().length, f = this._core.maximum(!0), g = this._core.settings, h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items; if ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)), g.dots || "page" == g.slideBy) for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) { if (b >= h || 0 === b) { if (this._pages.push({ start: Math.min(f, a - d), end: a - d + h - 1 }), Math.min(f, a - d) === f) break; b = 0, ++c } b += this._core.mergers(this._core.relative(a)) } }, e.prototype.draw = function () { var b, c = this._core.settings, d = this._core.items().length <= c.items, e = this._core.relative(this._core.current()), f = c.loop || c.rewind; this._controls.$relative.toggleClass("disabled", !c.nav || d), c.nav && (this._controls.$previous.toggleClass("disabled", !f && e <= this._core.minimum(!0)), this._controls.$next.toggleClass("disabled", !f && e >= this._core.maximum(!0))), this._controls.$absolute.toggleClass("disabled", !c.dots || d), c.dots && (b = this._pages.length - this._controls.$absolute.children().length, c.dotsData && 0 !== b ? this._controls.$absolute.html(this._templates.join("")) : b > 0 ? this._controls.$absolute.append(new Array(b + 1).join(this._templates[0])) : b < 0 && this._controls.$absolute.children().slice(b).remove(), this._controls.$absolute.find(".active").removeClass("active"), this._controls.$absolute.children().eq(a.inArray(this.current(), this._pages)).addClass("active")) }, e.prototype.onTrigger = function (b) { var c = this._core.settings; b.page = { index: a.inArray(this.current(), this._pages), count: this._pages.length, size: c && (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items) } }, e.prototype.current = function () { var b = this._core.relative(this._core.current()); return a.grep(this._pages, a.proxy(function (a, c) { return a.start <= b && a.end >= b }, this)).pop() }, e.prototype.getPosition = function (b) { var c, d, e = this._core.settings; return "page" == e.slideBy ? (c = a.inArray(this.current(), this._pages), d = this._pages.length, b ? ++c : --c, c = this._pages[(c % d + d) % d].start) : (c = this._core.relative(this._core.current()), d = this._core.items().length, b ? c += e.slideBy : c -= e.slideBy), c }, e.prototype.next = function (b) { a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b) }, e.prototype.prev = function (b) { a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b) }, e.prototype.to = function (b, c, d) { var e; !d && this._pages.length ? (e = this._pages.length, a.proxy(this._overrides.to, this._core)(this._pages[(b % e + e) % e].start, c)) : a.proxy(this._overrides.to, this._core)(b, c) }, a.fn.owlCarousel.Constructor.Plugins.Navigation = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { "use strict"; var e = function (c) { this._core = c, this._hashes = {}, this.$element = this._core.$element, this._handlers = { "initialized.owl.carousel": a.proxy(function (c) { c.namespace && "URLHash" === this._core.settings.startPosition && a(b).trigger("hashchange.owl.navigation") }, this), "prepared.owl.carousel": a.proxy(function (b) { if (b.namespace) { var c = a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash"); if (!c) return; this._hashes[c] = b.content } }, this), "changed.owl.carousel": a.proxy(function (c) { if (c.namespace && "position" === c.property.name) { var d = this._core.items(this._core.relative(this._core.current())), e = a.map(this._hashes, function (a, b) { return a === d ? b : null }).join(); if (!e || b.location.hash.slice(1) === e) return; b.location.hash = e } }, this) }, this._core.options = a.extend({}, e.Defaults, this._core.options), this.$element.on(this._handlers), a(b).on("hashchange.owl.navigation", a.proxy(function (a) { var c = b.location.hash.substring(1), e = this._core.$stage.children(), f = this._hashes[c] && e.index(this._hashes[c]); f !== d && f !== this._core.current() && this._core.to(this._core.relative(f), !1, !0) }, this)) }; e.Defaults = { URLhashListener: !1 }, e.prototype.destroy = function () { var c, d; a(b).off("hashchange.owl.navigation"); for (c in this._handlers) this._core.$element.off(c, this._handlers[c]); for (d in Object.getOwnPropertyNames(this)) "function" != typeof this[d] && (this[d] = null) }, a.fn.owlCarousel.Constructor.Plugins.Hash = e }(window.Zepto || window.jQuery, window, document), function (a, b, c, d) { function e(b, c) { var e = !1, f = b.charAt(0).toUpperCase() + b.slice(1); return a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) { if (g[b] !== d) return e = !c || b, !1 }), e } function f(a) { return e(a, !0) } var g = a("<support>").get(0).style, h = "Webkit Moz O ms".split(" "), i = { transition: { end: { WebkitTransition: "webkitTransitionEnd", MozTransition: "transitionend", OTransition: "oTransitionEnd", transition: "transitionend" } }, animation: { end: { WebkitAnimation: "webkitAnimationEnd", MozAnimation: "animationend", OAnimation: "oAnimationEnd", animation: "animationend" } } }, j = { csstransforms: function () { return !!e("transform") }, csstransforms3d: function () { return !!e("perspective") }, csstransitions: function () { return !!e("transition") }, cssanimations: function () { return !!e("animation") } }; j.csstransitions() && (a.support.transition = new String(f("transition")), a.support.transition.end = i.transition.end[a.support.transition]), j.cssanimations() && (a.support.animation = new String(f("animation")), a.support.animation.end = i.animation.end[a.support.animation]), j.csstransforms() && (a.support.transform = new String(f("transform")), a.support.transform3d = j.csstransforms3d()) }(window.Zepto || window.jQuery, window, document);

function ajaxProduct(obj) {
  if (obj) {
    // return $.getJSON("https://cel.zyberclients.co.nz/tbc/?id=575863619616");
    //       return $.getJSON("https://cel.zyberclients.co.nz/tbc/?id=" + obj.productId);
    return $.getJSON(mainurl + "/api/productInfo/" + obj.productId);
  }
}

var html = {
  "id": '#beautyChef_questionnaire'
},
  mainurl = "https://questionnaireau.thebeautychef.com",
  lastproduct = 0,
  name = '',
  cart = [],
  products = [],
  secondaryProducts = [],
  combinationMatch = false,
  isMedical = false,
  item = [],
  info = '',
  secondaryItem = [],
  gutItem = [],
  productUnavailable = false,
  bundleID = [],
  allPrettyDescs = '';

$(function () {
  var token = gettoken();
  getproducts(token);
});

function gettoken() {
  var parameterName = "token";
  var result = null,
    tmp = [];
  var items = location.search.substr(1).split("&");
  for (var index = 0; index < items.length; index++) {
    tmp = items[index].split("=");
    if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
  }
  return result;
}

function getproducts(token) {
  $.ajax({
    type: "GET",
    url: mainurl + "/api/recommendations/" + token
  }).done(function (data) {
    products = data.primaryProducts;
    secondaryProducts = data.secondaryProducts;
    name = data.name;
    info = data.info;
    gutItem = data.gutPrimerProduct;
    allPrettyDescs = data.primaryPretty;
    console.log(data);

    const cookieKey = document.cookie
      .split('; ')
      .find(row => row.startsWith('tbc_quiz_e='))



    console.log(cookieKey);
    // TODO
    if (cookieKey) {
      let cookieValue = cookieKey.split('=')[1];
      let primary1 = data.primaryProducts[0] ? data.primaryProducts[0].product : null;
      let primary2 = data.primaryProducts[1] ? data.primaryProducts[1].product : null;
      let primary3 = data.primaryProducts[2] ? data.primaryProducts[2].product : null;

      $.when(ajaxProduct(primary1), ajaxProduct(primary2), ajaxProduct(primary3)).done(function (product1, product2, product3) {
        console.log(product1, product2, product3)

        $.ajax({
          type: "POST",
          url: "https://australia-southeast1-the-beauty-chef-quiz.cloudfunctions.net/handleQuizResults",
          data: {
            "email": cookieValue,
            "id": data.info.id,
            "product_1": product1 ? product1[0].product.handle : "",
            "product_2": product2 ? product2[0].product.handle : "",
            "product_3": product3 ? product3[0].product.handle : "",
            "date": data.info.created_at,
            "token": data.info.sessionId,
            "score": data.info.score ? data.info.score : 0,
            "status": data.info.status,
            "name": data.name
          }
        }).done(function (data) {
          console.error("Submitted quiz to GCP:", data);
        }).fail(function () {
          console.error("Error submitting quiz data to GCP");
        });
      })

    }

    if (products.length > 0) {
      initiate_render();
    } else {
      errorPage();
    }

  }).fail(function () {
    errorPage();
  });
}

function errorPage() {
  let nohtml = '<div class="tbc-content__header">' +
    '<div class="tbc-content-wrapper">' +
    '<p class="tbc-content__main-header">' +
    'An error has occured' +
    '</p>' +
    '<p class="tbc-content__sub-header">' +
    'We are unable to generate any products for you. Please try again.' +
    '</p>' +
    '<a class="btn" href="/pages/questionnaire">Try Again</a>' +
    '</div>' +
    '</div>';
  $('#tbc-content').html(nohtml);
  $('#shopify-section-page-questionnaire-results > .tbc-content__header').addClass('hide');
  pageload('hide');
}

function initiate_render() {
  var productListHtmlFull = "",
    productHtmlFull = "",
    productBundleHtmlFull = "",
    productSecondaryHtmlFull = "",
    firstName = name,
    count = products.length,
    price = 0,
    ele = {
      "firstName": '[data-first-name]',
      "count": '[data-recommended-count]',
      "prettyDescription": '[data-pretty-description]',
      "dietaryDescription": '[data-dietary-description]',
      "productList": '[data-list]',
      "productListItem": '[data-list-item]',
      "productCount": '[data-recommended-count]',
      "productName": '[data-product-name]',
      "productDescWrapper": '[data-product-wrapper]',
      "productBundle": '[data-product-bundle]',
      "productDesc": '[data-description]',
      "productIcons": '[data-icons]',
      "accordion": '[data-accordion]',
      "accordionHeader": '[data-accordion-header]',
      "accordionContent": '[data-accordion-content]',
      "priceTotal": '[data-price-total]',
      "priceDiscountTotal": '[data-discount-total]',
      "secondaryWrapper": '[data-secondary-products]'
    };
  $(products).each(function (i, product) {
    item[i] = {
      "productName": productName(product.product.title),
      "productNameShort": metafieldContent(product, 'zyber', 'short_name'),
      "productHandle": '',
      "category": productCategory(product, ['remedy_essentials', 'remedy_support', 'remedy_boosts', 'remedy_other'], ['Your Essential', 'Your Support', 'Your Boost', 'Other']),
      "productPrice": '',
      "productId": product.product.productId,
      "variantId": product.product.variantId,
      "variants": '',
      "options": '',
      "icons": '',
      "descriptions": '',
      "image": '',
      "keywords": metafieldContent(product, 'global', 'product_small_info'),
      "sellingPoint": metafieldContent(product, 'global', 'mini_heading'),
      "about": metafieldContent(product, 'zyber', 'zyber>description'),
      "goodToKnow": metafieldContent(product, 'zyber', 'good_to_know'),
      "howToUse": metafieldContent(product, 'zyber', 'zyber>dosage'),
      "ingredients": metafieldContent(product, 'zyber', 'zyber>ingredients'),
      "disclaimer": metafieldContent(product, 'zyber', 'zyber>dietary_disclaimer'),
      "reviewAve": metafieldContent(product, 'okendo', 'RatingAndReviewAverageValue'),
      "reviewCount": metafieldContent(product, 'okendo', 'ReviewCount'),
      "metafields": product.all_meta_fields,
      "isMedical": is_medical(product, true)
    };
  });

  disclaimerPopup();

  //Check if tag 'TGA' exist
  function is_medical(product, global) {
    var tags = product.product.tags.split(', ');
    for (var k = 0; k < tags.length; k++) {
      if (tags[k] == 'TGA') {
        if (global) {
          isMedical = true;
        }
        return true;
      }
    }
    return false;
  }

  //Rearrange the products according to Essential > Boost > Support
  function rearrangeItems() {
    let tmp = item,
      order = ['Your Essential', 'Your Boost', 'Your Support', 'Other', null, 'Gut Primer'];
    item = [];
    $(order).each(function (i, cat) {
      $(tmp).each(function (i, obj) {
        if (obj.category == cat) {
          item.push(obj);
        }
      });
    });

    bundleID = [];
    for (var k = 0; k < item.length; k++) {
      bundleID.push(item[k].variantId);
    }
    console.log(bundleID);
  }

  function rearrangeGutItems() {
    for (var n = 0; n < item.length; n++) {
      if (item[n].productId == gutItem.productId) {
        item[n].category = 'Gut Primer';
      }
    }
    rearrangeItems();
  }

  if (info.score > 10 && info.score < 21) {
    rearrangeGutItems();
  } else {
    rearrangeItems();
  }
  if (secondaryProducts.length > 0) {
    $(secondaryProducts).each(function (i, product) {
      secondaryItem[i] = {
        "productName": productName(product.product.title),
        "productHandle": '',
        "productPrice": '',
        "productId": product.product.productId,
        "variantId": product.product.variantId,
        "variants": '',
        "image": '',
        "url": '',
        "reviewAve": metafieldContent(product, 'okendo', 'RatingAndReviewAverageValue'),
        "metafields": product.all_meta_fields,
        "isMedical": is_medical(product, false)
      };
    });
  } else {
    $('.tbc-content__secondary').addClass('hide');
  }

  function disclaimerPopupButton() {
    var popupBtn = "#disclaimer_btn",
      popup = '.disclaimer_popup';
    $('body').addClass('stop-scroll');
    $(popupBtn).on('click', function () {
      $(popup).addClass('hide');
      $('body').removeClass('stop-scroll');
    })
  }
  disclaimerPopupButton();

  function productName(title) {
    var splitTitles = $('[data-split-title]').text().split(','),
      split_product_title = title.split(' '),
      product_first_word = split_product_title[0],
      product_two_word = product_first_word + ' ' + split_product_title[1],
      product_three_word = product_two_word + ' ' + split_product_title[2],
      product_four_word = product_three_word + ' ' + split_product_title[3],
      cap_titlesplit = '';
    for (var i = 0; i < splitTitles.length; i++) {
      var splitTitle = splitTitles[i],
        strip_split_title = $.trim(splitTitle),
        strip_split_title_down = strip_split_title.toLowerCase(),
        strip_split_title_up = strip_split_title.toUpperCase(),
        striptitle_word = strip_split_title.split(' '),
        striptitle_word_size = striptitle_word.length;

      if (striptitle_word_size == 4) {
        if (product_four_word == strip_split_title || product_four_word == strip_split_title_down || product_four_word == strip_split_title_up) {
          cap_titlesplit = '<span>' + strip_split_title_up + '</span><br />' + title.replace(strip_split_title, "").replace(strip_split_title_down, "").replace(strip_split_title_up, "");
        }
      } else if (striptitle_word_size == 3) {
        if (product_three_word == strip_split_title || product_three_word == strip_split_title_down || product_three_word == strip_split_title_up) {
          cap_titlesplit = '<span>' + strip_split_title_up + '</span><br />' + title.replace(strip_split_title, "").replace(strip_split_title_down, "").replace(strip_split_title_up, "");
        }
      } else if (striptitle_word_size == 2) {
        if (product_two_word == strip_split_title || product_two_word == strip_split_title_down || product_two_word == strip_split_title_up) {
          cap_titlesplit = '<span>' + strip_split_title_up + '</span><br />' + title.replace(strip_split_title, "").replace(strip_split_title_down, "").replace(strip_split_title_up, "");
        }
      } else if (striptitle_word_size == 1) {
        if (product_first_word == strip_split_title || product_first_word == strip_split_title_down || product_first_word == strip_split_title_up) {
          cap_titlesplit = '<span>' + strip_split_title_up + '</span><br />' + title.replace(strip_split_title, "").replace(strip_split_title_down, "").replace(strip_split_title_up, "");
        }
      }
    }
    if (cap_titlesplit != '') {
      return cap_titlesplit;
    } else {
      return title;
    }
  }

  function metafieldContent(product, nameSpace, key) {
    for (var i = 0; i < product.all_meta_fields.length; i++) {
      if (product.all_meta_fields[i].nameSpace == nameSpace && product.all_meta_fields[i].key == key) {
        return product.all_meta_fields[i].value;
      }
    }
    return null;
  }

  function productCategory(product, tagNames, categoryNames) {
    let tags = product.product.tags.split(', ');

    for (var i = 0; i < tagNames.length; i++) {
      for (var k = 0; k < tags.length; k++) {
        if (tags[k] == tagNames[i]) {
          return categoryNames[i];
          break;
        }
      }
    }
    return null;
  }

  var prettyDescriptionHtml = prettyDescription('pretty');
  var dietaryDescriptionHtml = prettyDescription('dietary');
  function prettyDescription(type) {
    var html = '',
      keywords = {
        'dietary': 'Dietary: ',
        'skin': 'Skin: ',
        'wellbeing': 'Wellbeing: '
      },
      prettyDescriptions = [],
      dietaryDescriptions = [];


    for (var i = 0; i < allPrettyDescs.length; i++) {
      let str = allPrettyDescs[i];
      if (str.startsWith(keywords.dietary) == true) {
        let description = str.replace(keywords.dietary, '');
        if ($.inArray(description, dietaryDescriptions) == -1) dietaryDescriptions.push(description);
      } else if (str.startsWith(keywords.skin) == true || str.startsWith(keywords.wellbeing) == true) {
        if ($.inArray(str, prettyDescriptions) == -1) prettyDescriptions.push(str);
      }
    };

    var skinDescription = prettyCleanF(keywords.skin),
      wellbeingDescription = prettyCleanF(keywords.wellbeing);
    function prettyCleanF(cat) {
      var tmp = prettyDescriptions,
        tmp2 = [];

      $(tmp).each(function (i, obj) {
        if (obj.startsWith(cat) == true) {
          tmp2.push(obj.replace(cat, ''));
        }
      });

      return tmp2;
    }

    if (type == 'dietary') {
      if (dietaryDescriptions.length) {
        html += '<h5>Dietary</h5>';
        $(dietaryDescriptions).each(function (i, obj) {
          html += '<p>' + obj + '</p>';
          //Insert dietary requirements into popup if they exist	
          $('.dietary_requirements').removeClass('hide');
          $('.dietary_requirements_text').html(dietaryDescriptions);
        });
      }
    } else if (type == 'pretty') {
      if (prettyDescriptions.length > 0) {
        if (skinDescription.length || wellbeingDescription.length) {

          html += '<p>As you shared that your main concerns were ';

          if (skinDescription.length && wellbeingDescription.length) {
            $.each(skinDescription, function (i, obj) {

              html += '<span>\'' + obj + '\'</span>';
              if ((i + 1) == skinDescription.length) { } else {
                html += ', ';
              }

            });
            html += ' as well as ';
            $.each(wellbeingDescription, function (i, obj) {

              html += '<span>\'' + obj + '\'</span>';
              if ((i + 1) == wellbeingDescription.length) { } else if ((i + 2) == wellbeingDescription.length) {
                html += ' and ';
              } else {
                html += ', ';
              }

            });
          } else if (skinDescription.length) {
            $.each(skinDescription, function (i, obj) {

              html += '<span>\'' + obj + '\'</span>';
              if ((i + 1) == skinDescription.length) { } else if ((i + 2) == skinDescription.length) {
                html += ' and ';
              } else {
                html += ', ';
              }

            });
          } else {
            $.each(wellbeingDescription, function (i, obj) {

              html += '<span>' + obj + '</span>';
              if ((i + 1) == wellbeingDescription.length) { } else if ((i + 2) == wellbeingDescription.length) {
                html += ' and ';
              } else {
                html += ', ';
              }

            });
          }

          html += ', we have recommended the following products...</p>';

        }
      } else {
        if (item.length == 1) {
          html = '<p>It seems like your primary focus right now is optimising your gut health and you\'ve indicated your symptoms are more severe. We\'ve recommended one optimal product for you - Gut Primer, which is to be taken in isolation until your symptoms improve. After this time, we strongly encourage you to retake Your Remedy to determine the suitability of our wider range.</p>';
          $('.tbc-content__sub-header').text('You have 1 recommendation.');
          $('[data-header-description]').text('We\'ve tailored a solution specifically for you based on your responses.');
        }
      }
    }
    return html;
  };


  $.when(ajaxProduct(item[0]), ajaxProduct(item[1]), ajaxProduct(item[2])).done(function (product1, product2, product3) {
    console.log(product1);
    console.log(product2);
    console.log(product3);
    item[0].productHandle = product1[0].product.handle;
    item[0].image = product1[0].product.image.src;
    for (var j = 0; j < product1[0].product.variants.length; j++) {
      if (product1[0].product.variants[j].id == item[0].variantId) {
        item[0].productPrice = product1[0].product.variants[j].price;
      }
    }
    item[0].options = product1[0].product.options;
    item[0].variants = product1[0].product.variants;

    if (item[1]) {
      item[1].productHandle = product2[0].product.handle;
      item[1].image = product2[0].product.image.src;
      for (var j = 0; j < product2[0].product.variants.length; j++) {
        if (product2[0].product.variants[j].id == item[1].variantId) {
          item[1].productPrice = product2[0].product.variants[j].price;
        }
      }
      item[1].options = product2[0].product.options;
      item[1].variants = product2[0].product.variants;
    }

    if (item[2]) {
      item[2].productHandle = product3[0].product.handle;
      item[2].image = product3[0].product.image.src;
      console.log('Item variant: '+ item[2].variantId);
      for (var j = 0; j < product3[0].product.variants.length; j++) {
        if (product3[0].product.variants[j].id == item[2].variantId) {
          item[2].productPrice = product3[0].product.variants[j].price;
        }
        else if (product3[0].product.variants[j].id == "39727842558040"){
          item[2].productPrice = product3[0].product.variants[j].price;
        }
        else{}
      }
      
      item[2].options = product3[0].product.options;
      item[2].variants = product3[0].product.variants;
      
    }

    checkVariantAvailability();

    buildItem(0);
    buildBundleProducts(0);
    if (item[1]) {
      buildItem(1);
      buildBundleProducts(1);
    }
    if (item[2]) {
      buildItem(2);
      buildBundleProducts(2);
    }

    let priceDiscounted = price / 100 * 85;
    if (products.length > 1) {
      $(ele.productList).html(productListHtmlFull);
    } else {
      $('#bundle-btn').closest('.tbc-content__recommended-sidebar').addClass('hide');
      $('.bundle-content__wrapper').addClass('hide');
    }
    $(ele.productDescWrapper).html(productHtmlFull);
    $(ele.productBundle).html(productBundleHtmlFull);
    $(ele.firstName).html(firstName);
    $(ele.prettyDescription).html(prettyDescriptionHtml);
    $(ele.count).html(count);
    $(ele.priceTotal).html(money(price));
    $(ele.priceDiscountTotal).html(money(priceDiscounted));

    if ($('[data-afterpay-bundle]').data('currency') == 'USD') {
      if (priceDiscounted >= 35) {
        var afterpaySnippetBundle = $('[data-afterpay-bundle]').html().replace('[PRICE]', parseFloat(priceDiscounted / 4).toFixed(2));
      }
    } else {
      if (priceDiscounted >= 0.04) {
        var afterpaySnippetBundle = $('[data-afterpay-bundle]').find('.afterpay-installment-bundle').html().replace('[PRICE]', parseFloat(priceDiscounted / 4).toFixed(2));
      }
    }

    $('[data-afterpay-bundle]').find('.afterpay-installment-bundle').html(`$${afterpaySnippetBundle}`)


    accordion();
    variantSwap();
    bundleAddToCart();
    medicalPopupButton();
    subcriptionAddToCart();
    viewMore();
    if (window.innerWidth < 769) {
      $('html').scrollTop(0);
    }
    pageload('hide');
    checkCart();
  });
  $.when(ajaxProduct(secondaryItem[0]), ajaxProduct(secondaryItem[1]), ajaxProduct(secondaryItem[2]), ajaxProduct(secondaryItem[3])).done(function (product1, product2, product3, product4) {
    if (secondaryItem[0]) {
      secondaryItem[0].productHandle = product1[0].product.handle;
      secondaryItem[0].image = product1[0].product.image.src;
      for (var j = 0; j < product1[0].product.variants.length; j++) {
        if (product1[0].product.variants[j].id == secondaryItem[0].variantId) {
          secondaryItem[0].productPrice = product1[0].product.variants[j].price;
        }
      }
      secondaryItem[0].variants = product1[0].product.variants;
    }
    if (secondaryItem[1]) {
      secondaryItem[1].productHandle = product2[0].product.handle;
      secondaryItem[1].image = product2[0].product.image.src;
      for (var j = 0; j < product2[0].product.variants.length; j++) {
        if (product2[0].product.variants[j].id == secondaryItem[1].variantId) {
          secondaryItem[1].productPrice = product2[0].product.variants[j].price;
        }
      }
      secondaryItem[1].variants = product2[0].product.variants;
    }
    if (secondaryItem[2]) {
      secondaryItem[2].productHandle = product3[0].product.handle;
      secondaryItem[2].image = product3[0].product.image.src;
      for (var j = 0; j < product3[0].product.variants.length; j++) {
        if (product3[0].product.variants[j].id == secondaryItem[2].variantId) {
          secondaryItem[2].productPrice = product3[0].product.variants[j].price;
        }
      }
      secondaryItem[2].variants = product3[0].product.variants;
    }
    if (secondaryItem[3]) {
      secondaryItem[3].productHandle = product4[0].product.handle;
      secondaryItem[3].image = product4[0].product.image.src;
      for (var j = 0; j < product4[0].product.variants.length; j++) {
        if (product4[0].product.variants[j].id == secondaryItem[3].variantId) {
          secondaryItem[3].productPrice = product4[0].product.variants[j].price;
        }
      }
      secondaryItem[3].variants = product4[0].product.variants;
    }

    if (secondaryItem[0]) {
      buildSecondaryProducts(0);
    }
    if (secondaryItem[1]) {
      buildSecondaryProducts(1);
    }
    if (secondaryItem[2]) {
      buildSecondaryProducts(2);
    }
    if (secondaryItem[3]) {
      buildSecondaryProducts(3);
    }

    $(ele.secondaryWrapper).html(productSecondaryHtmlFull);
    productCarousel('.tbc-content__secondary [data-secondary-products]');

  });


  console.log($.getJSON("https://cel.zyberclients.co.nz/tbc/?id=575863619616"));

  function buildItem(k) {
    let productListHtml = "",
      productHtml = "",
      hasVariants = false;

    if (item[k].variants.length > 1) {
      hasVariants = true;
    }

    productListHtml += '<li data-id="recommended-' + k + '"' + 'class="tab-selector';
    if (k === 0) {
      productListHtml += ' active"';
    } else {
      productListHtml += '"';
    }
    productListHtml += ' data-list-item data-i="' + (k + 1) + '"' + '><div class="content__list-content-wrap">' +
      '<h4>';
    //productListHtml += (k + 1) + '. ';
    if (k === 0) {
      productListHtml += 'Step 1';
    } else if (k === 1) {
      productListHtml += 'Step 2';
    } else if (k === 2) {
      productListHtml += 'Step 3';
    }
    productListHtml += '</h4>' + '<p class="title">';
    if (item[k].productNameShort) {
      productListHtml += item[k].productNameShort;
    } else {
      productListHtml += item[k].productName.split('<br />')[0];
    }
    productListHtml += '</p>' + '</div></li>';

    if (item.length > 1) {
      productHtml += '<div data-id="recommended-' + k + '"' + 'class="mobile-tab-selector';
      if (k === 0) {
        productHtml += ' active"';
      } else {
        productHtml += '"';
      }
      productHtml += ' data-list-item data-i="' + (k + 1) + '"' + '><div class="content__list-content-wrap">' + '<h4>' + (k + 1) + '. ';
      if (k === 0) {
        productHtml += 'Step 1';
      } else if (k === 1) {
        productHtml += 'Step 2';
      } else if (k === 2) {
        productHtml += 'Step 3';
      }
      productHtml += '</h4>' +
        '<p class="title">';
      if (item[k].productNameShort) {
        productHtml += item[k].productNameShort;
      } else {
        productHtml += item[k].productName.split('<br />')[0];
      }
      productHtml += '</p>' +
        '</div></div>';
    }

    productHtml += '<div class="rp-grid__wrapper primary-recommended-' + k;
    if (k === 0) {
      productHtml += ' active';
    }
    if (item.length < 2) {
      productHtml += ' small--show';
    }

    productHtml += '" data-recommended-product="recommended-' + k + '"><div class="rp-grid grid">' +
      '<div class="grid__item image">' +
      '<img src="' + item[k].image + '" alt="' + item[k].productName + '">' +
      '</div>' +
      '<div class="grid__item meta">' +
      '<h2>' + item[k].productName + '</h2>';
    if (item[k].reviewAve) {
      let starPercentage = parseFloat(item[k].reviewAve) * 20;
      productHtml += '<div class="stars__wrapper medium-up--hide"><div class="price">' + money(item[k].productPrice) + '</div><div class="stars">' +
        '<span class="star" style="width: ' + starPercentage + '%"></span>' +
        '</div></div>';
    }
    productHtml += '<div class="rp-icons" data-icons>';
    $(item[k].icons).each(function (k, icon) {
      productHtml += '<div class="rp-icon">' +
        '<img src="https://kylepremierstorage.com/wp-content/uploads/2015/10/placeholder-circle-300x300.png" alt="' + icon + '">' +
        '<h5>' + icon + '</h5>' +
        '</div>';
    });
    productHtml += '</div>' +
      '<div class="content">' +
      '<div class="description">';
    if (item[k].keywords) {
      productHtml += '<p class="keywords">' + item[k].keywords + '</p>';
    }
    if (item[k].sellingPoint) {
      productHtml += '<p class="sellingPoint">' + item[k].sellingPoint + '</p>';
    }
    if (item[k].reviewAve) {
      var starPercentage = parseFloat(item[k].reviewAve) * 20;
      productHtml += '<div class="stars__wrapper"><div class="stars">' +
        '<span class="star" style="width: ' + starPercentage + '%"></span>' +
        '</div><div class="review-total">' + item[k].reviewCount + ' Reviews</div></div>';
    }
    productHtml += '<div class="product-form-controls';
    if (hasVariants) {
      productHtml += ' has-variants';
    }
    productHtml += '"><div class="quantity-wrapper"><input type="number" id="Quantity" class="input-quantity" name="quantity" value="1" min="1" readonly="readonly""></div>';
    if (hasVariants) {
      productHtml += '<div class="variants-wrapper">';
      for (var n = 0; n < item[k].options.length; n++) {
        let option = item[k].options[n];
        productHtml += '<div class="select-options js variant-' + (n + 1) + ' ">' +
          '<div class="select-wrapper">' +
          '<select id="Option' + (n + 1) + '" class="productVariantSelect" name="options[' + option.name + ']" data-option-select>';
        for (var p = 0; p < option.values.length; p++) {
          let value = option.values[p];
          productHtml += '<option value="' + value + '"';
          if (p == 0) {
            productHtml += ' selected="selected"';
          }
          productHtml += '>' + value + '</option>';
        }
        productHtml += '</select>' +
          '</div>' +
          '</div>';
      }

      productHtml += '<div class="select-wrapper hidden"><select id="productVariantSelect-' + item[k].productId + '" class="productVariantSelect" data-product-id="' + item[k].productId + '" data-variant-select>';

      for (var m = 0; m < item[k].variants.length; m++) {
        let variant = item[k].variants[m];
        productHtml += '<option value="' + variant.id + '" data-title="' + variant.title + '" data-price="' + variant.price + '"';
        if (variant.inventory_management != null &&  variant.inventory_quantity == 0) {
          productHtml += ' disabled';
        }
        if (variant.id == item[k].variantId) {
          productHtml += ' selected';
        }
        productHtml += '>';
        if (variant.inventory_management != null && variant.inventory_quantity == 0) {
          productHtml += '(Sold Out) ';
        }
        productHtml += variant.title + '</option>';
      }

      productHtml += '</select></div></div>';
    }
    let c = item[k].variantId;
    if ( c == '39320108204120'){
      c = "39727842558040";
    }
    productHtml += '<button class="btn btn-secondary add-to-cart-btn" onclick="singleAddToCart(\'.primary-recommended-' + k + ' .add-to-cart-btn\')" data-variant-id="' + c + '" data-question-id="' + (k + 1) + '" data-handle="' + item[k].productHandle + '"';
    if (item[k].isMedical) {
      productHtml += ' data-tga="true"';
    }

    // button with price
    productHtml += '>Add to Cart' + '<span>|</span>' + '<span class="add-to-cart-btn-price">' + money(item[k].productPrice) + '</span>' + '</button></div>';
    //productHtml += '>Add to Cart</button></div>';

    var afterpaySnippet = '';
    if ($('[data-afterpay]').data('currency') == 'USD') {
      if (item[k].productPrice >= 35) {
        var afterpaySnippet = $('[data-afterpay]').html().replace('[PRICE]', money(item[k].productPrice / 4)).replace('data-product-id=""', 'data-product-id="' + item[k].productId + '"');
      }
    } else {
      if (item[k].productPrice >= 0.04) {
        var afterpaySnippet = $('[data-afterpay]').html().replace('[PRICE]', money(item[k].productPrice / 4)).replace('data-product-id=""', 'data-product-id="' + item[k].productId + '"');
      }
    }
    if (afterpaySnippet != '') {
      productHtml += '<div class="afterpay__wrapper">' + afterpaySnippet + '</div>';
    }
    productHtml += '<div class="accordion-container">' +
      '<div class="accordion" data-accordion>';
    if (item[k].about) {
      productHtml += '<div class="accordion-header" data-accordion-header>' +
        '<h5>About</h5>' +
        '</div>' +
        '<div class="accordion-content" data-accordion-content>' +
        '<div class="rte">' +
        item[k].about +
        '</div></div>';
    }
    if (item[k].goodToKnow) {
      productHtml += '<div class="accordion-header" data-accordion-header>' +
        '<h5>Good To Know</h5>' +
        '</div>' +
        '<div class="accordion-content" data-accordion-content>' +
        '<div class="rte">' +
        item[k].goodToKnow +
        '</div></div>';
    }
    if (item[k].howToUse) {
      productHtml += '<div class="accordion-header" data-accordion-header>' +
        '<h5>How To Use</h5>' +
        '</div>' +
        '<div class="accordion-content" data-accordion-content>' +
        '<div class="rte">' +
        item[k].howToUse +
        '</div></div>';
    }
    if (item[k].ingredients) {
      productHtml += '<div class="accordion-header" data-accordion-header>' +
        '<h5>Hero Ingredients</h5>' +
        '</div>' +
        '<div class="accordion-content" data-accordion-content>' +
        '<div class="rte">' +
        item[k].ingredients +
        '</div></div>';
    }
    if (dietaryDescriptionHtml) {
      productHtml += '<div class="accordion-header" data-accordion-header>' +
        '<h5>Dietary</h5>' +
        '</div>' +
        '<div class="accordion-content" data-accordion-content>' +
        '<div class="rte">' +
        dietaryDescriptionHtml.split('</h5>')[1] +
        '</div></div>';
    }
    if (item[k].disclaimer) {
      productHtml += '<div class="accordion-header" data-accordion-header>' +
        '<h5>Dietary Disclaimer</h5>' +
        '</div>' +
        '<div class="accordion-content" data-accordion-content>' +
        '<div class="rte">' +
        item[k].disclaimer +
        '</div></div>';
    }
    productHtml += '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>';
    productListHtmlFull += productListHtml;
    productHtmlFull += productHtml;
    price += parseFloat(item[k].productPrice);

    outOfStockProduct(item[k].productHandle, item[k].variantId, item[k].variants[0].inventory_quantity, item[k].variants[0].inventory_policy, item[k].variants[0].inventory_management);
  }

  function outOfStockProduct(handle, var_id, inventory_quantity, inventory_policy, inventory_management) {

    if (inventory_quantity < 1 && inventory_policy == 'deny' && inventory_management == 'shopify') {
      setTimeout((function () {
        $('button.add-to-cart-btn[data-variant-id="' + var_id + '"]').addClass('disabled');
        $('button.add-to-cart-btn[data-variant-id="' + var_id + '"]').html('Out of Stock');
      }), 100);

    }


    $.getJSON('/products/' + handle + '.js', function (product) {
      if (product.tags.includes('Quiz OOS')) {
        $('#beautyChef_questionnaire .recommendation-body .tbc-content__button').addClass('hide');
        $('#beautyChef_questionnaire .recommendation-body .bundle-content__wrapper .mobile-tab-selector').addClass('hide');
        $('#beautyChef_questionnaire .recommendation-body .tbc-content__list').addClass('full');
        $('button.add-to-cart-btn[data-variant-id="' + var_id + '"]').addClass('disabled');
        $('button.add-to-cart-btn[data-variant-id="' + var_id + '"]').html('Out of Stock');
      }
    });
  }

  function buildBundleProducts(k) {
    let productHtml = "",
      hasVariants = false;
    if (item[k].variants.length > 1) {
      hasVariants = true;
    }
    productHtml += '<div class="grid__item">' +
      '<div class="image__wrapper">' +
      '<a href="/products/' + item[k].productHandle + '">' +
      '<img src="' + item[k].image + '" alt="' + item[k].productName + '" />' +
      '</a>';
    if (hasVariants) {
      productHtml += '<div class="select-wrapper "><select onchange="bundleVariantSwap(' + k + ')" class="quick-variant-selector" id="productVariantQuick-' + k + '" data-product-id="' + item[k].productId + '" data-variant-select>';

      for (var m = 0; m < item[k].variants.length; m++) {
        let variant = item[k].variants[m];
        productHtml += '<option value="' + variant.id + '" data-title="' + variant.title + '" data-price="' + variant.price + '"';
        if (variant.inventory_quantity == 0) {
          productHtml += ' disabled';
        }
        if (variant.id == item[k].variantId) {
          productHtml += ' selected';
        }
        productHtml += '>';
        if (variant.inventory_quantity == 0) {
          productHtml += '(Sold Out) ';
        }
        productHtml += variant.title + '</option>';
      }

      productHtml += '</select></div>';
    }
    productHtml += '</div>' +
      '<div class="product__meta">' +
      '<h3>' + item[k].productName + '</h3>' +
      '<div class="product__meta-info"><p class="product__price"><s>' + money(item[k].productPrice) + '</s><span>' + money(item[k].productPrice / 100 * 85) + '</span></p>';
    if (item[k].reviewAve) {
      var reviewCount = item[k].reviewAve;
      var starPercentage = parseFloat(reviewCount) * 20;
      productHtml += '<div class="stars__wrapper"><div class="stars">' +
        '<span class="star" style="width: ' + starPercentage + '%"></span>' +
        '</div></div>';
    }

    productHtml += '</div></div>';

    if (hasVariants) {
      productHtml += '<div class="select-wrapper select-wrapper-mobile"><select onchange="bundleVariantSwapMobile(' + k + ')" class="quick-variant-selector" id="secondProductVariantQuick-' + k + '" data-product-id="' + item[k].productId + '" data-variant-select>';

      for (var m = 0; m < item[k].variants.length; m++) {
        let variant = item[k].variants[m];
        productHtml += '<option value="' + variant.id + '" data-title="' + variant.title + '" data-price="' + variant.price + '"';
        if (variant.inventory_quantity == 0) {
          productHtml += ' disabled';
        }
        if (variant.id == item[k].variantId) {
          productHtml += ' selected';
        }
        productHtml += '>';
        if (variant.inventory_quantity == 0) {
          productHtml += '(Sold Out) ';
        }
        productHtml += variant.title + '</option>';
      }

      productHtml += '</select></div>';
    }
    productHtml += '</div></div>';

    productBundleHtmlFull += productHtml;
  }

  function buildSecondaryProducts(k) {
    var productSecondaryHtml = "",
      hasVariants = false;
    if (secondaryItem[k].variants.length > 1) {
      hasVariants = true;
    }
    productSecondaryHtml += '<div class="grid__item secondary-recommended-' + k + '">' +
      '<div class="image__wrapper">' +
      '<a href="/products/' + secondaryItem[k].productHandle + '" class="">' +
      '<img src="' + secondaryItem[k].image + '" alt="' + secondaryItem[k].productName + '" />' +
      '</a>' +
      '<button class="btn btn-secondary add-to-cart-btn secondary-add-to-cart-btn secondary-desktop-add-to-cart-btn" onclick="singleAddToCart(\'.secondary-recommended-' + k + ' .add-to-cart-btn\')" data-variant-id="' + secondaryItem[k].variantId + '"';
    if (secondaryItem[k].isMedical) {
      productSecondaryHtml += ' data-tga="true"';
    }
    productSecondaryHtml += '>Add to Cart' + '<span></button>';
    if (hasVariants) {
      productSecondaryHtml += '<div class="select-wrapper "><select onchange="secondaryVariantSwap(' + k + ')" class="quick-variant-selector" id="secondaryVariantQuick-' + k + '" data-product-id="' + secondaryItem[k].productId + '" data-variant-select>';

      for (var m = 0; m < secondaryItem[k].variants.length; m++) {
        let variant = secondaryItem[k].variants[m];
        productSecondaryHtml += '<option value="' + variant.id + '" data-title="' + variant.title + '" data-price="' + variant.price + '"';
        if (variant.inventory_quantity == 0) {
          productSecondaryHtml += ' disabled';
        }
        if (variant.id == secondaryItem[k].variantId) {
          productSecondaryHtml += ' selected';
        }
        productSecondaryHtml += '>';
        if (variant.inventory_quantity == 0) {
          productSecondaryHtml += '(Sold Out) ';
        }
        productSecondaryHtml += variant.title + '</option>';
      }

      productSecondaryHtml += '</select></div>';
    }
    productSecondaryHtml += '</div>' +
      '<div class="product__meta">' +
      '<h3>' + secondaryItem[k].productName + '</h3>' +
      '<div class="product__meta-info"><p class="product__price">' + money(secondaryItem[k].productPrice) + '</p>';
    if (secondaryItem[k].reviewAve) {
      var reviewCount = secondaryItem[k].reviewAve;
      var starPercentage = parseFloat(reviewCount) * 20;
      productSecondaryHtml += '<div class="stars__wrapper"><div class="stars">' +
        '<span class="star" style="width: ' + starPercentage + '%"></span>' +
        '</div></div></div>';
    }
    productSecondaryHtml += '</div>' +
      '<button class="btn btn-secondary add-to-cart-btn secondary-add-to-cart-btn secondary-mobile-add-to-cart-btn" onclick="singleAddToCart(\'.secondary-recommended-' + k + ' .add-to-cart-btn\')" data-variant-id="' + secondaryItem[k].variantId + '"';
    if (secondaryItem[k].isMedical) {
      productSecondaryHtml += ' data-tga="true"';
    }
    productSecondaryHtml += '>Add to Cart' + '<span></button></div>';

    productSecondaryHtmlFull += productSecondaryHtml;

    scondaryoutOfStockProduct(secondaryItem[k].productHandle, secondaryItem[k].variantId, secondaryItem[k].variants[0].inventory_quantity, secondaryItem[k].variants[0].inventory_policy, secondaryItem[k].variants[0].inventory_management);
    
    $(document).on('click', '.secondary-mobile-add-to-cart-btn', function (e) {
      //if (window.matchMedia('(max-width: 500px)').matches) {
        setTimeout((function () {
          $( ".cart-toggle" ).trigger( "click" );
        }), 1000);
      //}
    });
  }

  function scondaryoutOfStockProduct(handle, var_id, inventory_quantity, inventory_policy, inventory_management) {

    if (inventory_quantity < 1 && inventory_policy == 'deny' && inventory_management == 'shopify') {
      setTimeout((function () {
        $('button.secondary-add-to-cart-btn[data-variant-id="' + var_id + '"]').addClass('disabled');
        $('button.secondary-add-to-cart-btn[data-variant-id="' + var_id + '"]').html('Out of Stock');
      }), 100);

    }
    $.getJSON('/products/' + handle + '.js', function (product) {
      if (product.tags.includes('Quiz OOS')) {
        $('button.secondary-add-to-cart-btn[data-variant-id="' + var_id + '"]').addClass('disabled');
        $('button.secondary-add-to-cart-btn[data-variant-id="' + var_id + '"]').html('Out of Stock');
      }
    });
  }
}


function productCarousel(x) {

  if ($(window).width() < 769) {
    initiateCarousel();

    $(window).resize(function () {
      if ($(window).width() < 769) {
        initiateCarousel();
      } else {
        stopCarousel();
      }
    });
  }

  function initiateCarousel() {
    $(x).addClass('owl-carousel').addClass('owl-theme');
    $(x).owlCarousel({
      loop: true,
      dots: false,
      navText: ['', ''],
      items: 1,
      center: true,
      nav: true
    });
  }
  function stopCarousel() {
    $(x).trigger('destroy.owl.carousel');
    $(x).removeClass('owl-carousel');
  }
}

function money(val) {
  return new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(val);
}

function viewMore() {
  var recommendedListItem = '[data-list-item]',
    activeClassName = 'active',
    recommendedItem = '.rp-grid__wrapper',
    width = window.innerWidth;

  if (width < 769) {
    $(recommendedListItem).removeClass(activeClassName);
    $(recommendedItem).slideUp().removeClass(activeClassName);
  }

  $(document).on('click', recommendedListItem, function (e) {
    var listItemId = $(e.target).closest(recommendedListItem).attr('data-id');
    $(recommendedListItem).removeClass(activeClassName);
    $(e.target).closest(recommendedListItem).addClass(activeClassName);
    $(recommendedItem).each(function () {
      if ($(this).attr('data-recommended-product') === listItemId) {
        if (width < 769) {
          if ($(this).hasClass(activeClassName)) {
            $(e.target).closest(recommendedListItem).removeClass(activeClassName);
            $(this).slideUp(0).removeClass(activeClassName);
          } else {
            $(this).slideDown().addClass(activeClassName);
          }
        } else {
          $(this).addClass(activeClassName);
        }
      } else {
        if (width < 769) {
          $(this).slideUp(0).removeClass(activeClassName);
        } else {
          $(this).removeClass(activeClassName);
        }
      }
    });

    if (width < 769) {

      if ($(this).hasClass(activeClassName)) {
        $('html, body').animate(
          { scrollTop: $(this).offset().top - 54 },
          500
        );
      }
      console.log('done');

    }

  });
}

function disclaimerPopup() {
  $.each(quizCombinations, function (i, quizCombination) {
    var isCombiMatched = [];
    $.each(quizCombination.products, function (j, productId) {
      $.each(item, function (k, resultItem) {
        if (resultItem.productId === productId) {
          isCombiMatched.push(true);
        }
      });
    });
    if (isCombiMatched.length === 3) {
      combinationMatch = quizCombination.id;
    }
  });
  if (combinationMatch) {
    $('[data-combi-id="' + combinationMatch + '"]').removeClass('hide');
  }
}


function medicalPopupButton() {
  var popupBtn = '#medical-acceptance-btn',
    popupBtnBack = '#medical-back-btn';

  $(document).on('click', popupBtn, function () {

    $('.medical_popup').addClass('hide');
    $('.medical_popup').prop('data-button', '');

    var dataBtn = $(this).closest('.medical_popup').data('button');

    if (dataBtn == 'bundle') {
      runBundleAddtoCart();
    } else if (dataBtn.indexOf("single-") >= 0) {
      var variantId = $(this).closest('.medical_popup').attr('data-button').split('-')[1];
      var this_btn = $('button.add-to-cart-btn[data-variant-id="' + variantId + '"]');
      runSingleAddToCart(variantId, this_btn);
    } else if (dataBtn.indexOf("subscription-") >= 0) {
      var subscriptionIntervalVal = $(this).closest('.medical_popup').data('button').split('-')[1];
      runSubscriptionAddToCart(subscriptionIntervalVal);
    }
  });
  $(document).on('click', popupBtnBack, function () {
    $('.medical_popup').addClass('hide');
    $('.medical_popup').prop('data-button', '');
  });
}

function singleAddToCart(obj) {
  var this_btn = $(obj);
  var variantId = $(obj).attr('data-variant-id'),
    productIsMedical = $(obj).data('tga');

  console.log($(obj).attr('data-variant-id'));
  console.log(variantId);
  if (this_btn.hasClass('disable')) {
    alert('Item Added to Cart');
  } else {
    if (productIsMedical === true) {
      $('.medical_popup').removeClass('hide');
      $('.medical_popup').attr('data-button', 'single-' + variantId);
    } else {
      runSingleAddToCart(variantId, this_btn);
    }
  }


}

function runSingleAddToCart(variantId, this_btn) {
  var q_number = $($('.add-to-cart-btn[data-variant-id="' + variantId + '"]')).attr('data-question-id');
  var handle = $($('.add-to-cart-btn[data-variant-id="' + variantId + '"]')).attr('data-handle');
  if (this_btn.hasClass('secondary-add-to-cart-btn')) {
    var params = {
      quantity: $('[data-variant-id="' + variantId + '"]').closest('.product-form-controls').find('[name="quantity"]').val(),
      id: variantId
    };
  } else {
    var params = {
      quantity: $('[data-variant-id="' + variantId + '"]').closest('.product-form-controls').find('[name="quantity"]').val(),
      id: variantId,
      properties: {
        'Quiz Result': 'Quiz' + q_number + ' - ' + handle
      }
    };
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    },
    data: params
  }).done(function () {
    console.log('added');
    console.log("params: "+ JSON.stringify(params));
    this_btn.text('Item Added to Cart')
    this_btn.addClass('disabled')
    // console.log(params);
    // window.location.href = "/cart";
    initiateCart1();
    // setTimeout((function () {
    //   initiateCart1();
    // }), 1000);
  }).fail(function () {
    pageload('hide');
    alert('Something has gone wrong. Please try again!');
    console.log('failed');
  });
}

function bundleAddToCart() {
  var cartBtn = '[data-cart-bundle]';

  if (productUnavailable) {
    $(cartBtn).addClass('disabled');
    $('.tbc-content__bundle').append('<div class="error">Sorry the bundle option is currently unavailable. One or more products in this bundle is currently sold out.</div>');
    $('#beautyChef_questionnaire .recommendation-body .tbc-content__button').addClass('hide');
    $('#beautyChef_questionnaire .recommendation-body .bundle-content__wrapper .mobile-tab-selector').addClass('hide');
    $('#beautyChef_questionnaire .recommendation-body .tbc-content__list').addClass('full');
  } else {
    $(document).on('click', cartBtn, function (e) {
      e.preventDefault();
      runBundleAddtoCart();
      // if (isMedical){
      //   $('.medical_popup').removeClass('hide');
      //   $('.medical_popup').attr('data-button', 'bundle');
      // } else {
      //   runBundleAddtoCart();
      // }
    });
  }
}

function runBundleAddtoCart() {
  var params = {
    items: []
  };
  console.log('heeeeeerrre ' + bundleID)

  var arrayLength = bundleID.length;

  for (var i = 0; i < arrayLength; i++) {
    if ($('.add-to-cart-btn[data-variant-id="' + bundleID[i] + '"]').hasClass('disabled')) {

    } else {
      if (item[i]) {
        var quiz_count = i + 1;
        var temp = {
          quantity: 1,
          id: bundleID[i],
          properties: {
            'Quiz Result': 'Quiz' + quiz_count + ' - ' + item[i].productHandle
          }
        };
        params.items.push(temp);
      }
    }
  }


  // if (item[1]){
  //   var temp = {
  //     quantity: 1,
  //     id: bundleID[1],
  //     properties: {
  //       'Quiz Result': 'Quiz2 - ' + item[1].productHandle
  //     }
  //   };
  //   params.items.push(temp);
  // }
  // if (item[2]){
  //   var temp = {
  //     quantity: 1,
  //     id: bundleID[2],
  //     properties: {
  //       'Quiz Result': 'Quiz3 - ' + item[2].productHandle
  //     }
  //   };
  //   params.items.push(temp);
  // }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params
  }).done(function () {
    console.log('added');
    // window.location.href = "/cart";
    initiateCart1();
    $('.recommendation-body .rp-grid .product-form-controls .add-to-cart-btn').text('Item Added to Cart');
    $('.recommendation-body .rp-grid .product-form-controls .add-to-cart-btn').addClass('disabled');


    $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').text('Your Bundle is Already In The Cart');
    $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').addClass('disabled');

  }).fail(function () {
    pageload('hide');
    alert('Something has gone wrong. Please try again!');
    console.log('failed');
  });
}

function checkVariantAvailability() {
  $.each(item, function (i, obj) {
    $.each(obj.variants, function (j, variant) {
      if (obj.variantId == variant.id) {
        if (variant.inventory_quantity == 0) {
          $.each(obj.variants, function (k, tmp) {
            if (tmp.inventory_quantity != 0) {
              item[i].variantId = tmp.id;
              item[i].productPrice = tmp.price;
              return false;
            }
          });
          $('button.add-to-cart-btn[data-variant-id="' + item[i].variantId + '"]').addClass('disabled');
          $('button.add-to-cart-btn[data-variant-id="' + item[i].variantId + '"]').text('Out of Stock');
          $('#beautyChef_questionnaire .recommendation-body .tbc-content__button').addClass('hide')
        }
      }
    });
  });

  $.each(item, function (i, obj) {
    $.each(obj.variants, function (j, variant) {
      if (obj.variantId == variant.id) {
        if (variant.inventory_quantity == 0) {
          //A product is unavailable
          productUnavailable = true;
        }
      }
    });
  });

}

function goToBundleTab() {
  var selector = '.mobile-tab-selector[data-id="recommended_bundle"]';
  $('html, body').animate(
    { scrollTop: $(selector).offset().top },
    500
  );
  if (!$(selector).hasClass('active')) {
    $(selector).trigger('click');
  }
}

function bundleVariantSwap(num) {
  let value = $('#productVariantQuick-' + num).val();
  bundleID[num] = value;
}

function bundleVariantSwapMobile(num) {
  let value = $('#secondProductVariantQuick-' + num).val();
  bundleID[num] = value;
}

function secondaryVariantSwap(num) {
  let value = $('.secondary-recommended-' + num + ' .quick-variant-selector').val();
  $('.secondary-recommended-' + num + ' .add-to-cart-btn').attr('data-variant-id', value);
}

function variantSwap() {
  var variantEle = '[data-variant-select]',
    optionsEle = '[data-option-select]';

  $(document).on('change', optionsEle, function () {
    let variantValueAr = [],
      variantValue = '',
      productOptions = $(this).closest('.variants-wrapper').find(optionsEle),
      productVariants = $(this).closest('.variants-wrapper').find(variantEle);
    for (var i = 0; i < productOptions.length; i++) {
      let optionEle = productOptions[i];
      variantValueAr.push($(optionEle).find('option:selected').val());
    }
    variantValue = variantValueAr.join(' / ');
    let variantOptions = $(productVariants).find('option');

    for (var j = 0; j < variantOptions.length; j++) {
      let variantOption = variantOptions[j];

      if ($(variantOption).data('title') == variantValue) {
        $(variantOption).closest('select').val($(variantOption).val()).change();
      }
    }

  });

  $(document).on('change', variantEle, function () {
    var selectedOption = $(this).find('option:selected'),
      optionPrice = selectedOption.data('price'),
      optionId = $(this).val(),
      optionTitle = selectedOption.data('title');

    $(this).closest('.product-form-controls').find('.add-to-cart-btn-price').text(money(optionPrice));
    $(this).closest('.product-form-controls').find('.add-to-cart-btn').attr('data-variant-id', optionId);

    if ($(this).find('option:selected[disabled]').length > 0) {
      $(this).closest('.product-form-controls').find('.add-to-cart-btn').addClass('disabled');
      $(this).closest('.product-form-controls').find('.add-to-cart-btn-price').text('Sold Out');
    } else {
      $(this).closest('.product-form-controls').find('.add-to-cart-btn').removeClass('disabled');
    }

  });

}


function subcriptionAddToCart() {
  var cartBtn = '[data-cart-subscription]',
    subscriptionInterval = '#subscription-interval',
    subscriptionIntervalVal = '';

  $(document).on('click', cartBtn, function () {
    subscriptionIntervalVal = $(subscriptionInterval + ' option:selected').val();

    if (isMedical) {
      $('.medical_popup').removeClass('hide');
      $('.medical_popup').attr('data-button', 'subscription-' + subscriptionIntervalVal);
    } else {
      runSubscriptionAddToCart(subscriptionIntervalVal);
    }
  });
}

function runSubscriptionAddToCart(subscriptionIntervalVal) {
  var params = {
    items: [
      {
        quantity: 1,
        id: item[0].variantId,
        properties: {
          "shipping_interval_frequency": subscriptionIntervalVal,
          "shipping_interval_unit_type": "days"
        }
      }
    ]
  };
  if (item[1]) {
    var temp = {
      quantity: 1,
      id: item[1].variantId,
      properties: {
        "shipping_interval_frequency": subscriptionIntervalVal,
        "shipping_interval_unit_type": "days"
      }
    };
    params.items.push(temp);
  }
  if (item[2]) {
    var temp = {
      quantity: 1,
      id: item[2].variantId,
      properties: {
        "shipping_interval_frequency": subscriptionIntervalVal,
        "shipping_interval_unit_type": "days"
      }
    };
    params.items.push(temp);
  }
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: params
  }).done(function () {
    console.log('added');
    // window.location.href = "/cart";
    initiateCart1();
  }).fail(function () {
    pageload('hide');
    alert('Something has gone wrong. Please try again!');
    console.log('failed');
  });
}

function accordion() {
  var accordionDiv = $('.accordion');
  if (accordionDiv.length) {
    $('.accordion-header').toggleClass('inactive-header');

    //Set The Accordion Content Width
    var contentwidth = $('.accordion-header').width();
    $('.accordion-content').css({ 'width': contentwidth });

    //Open The First Accordion Section When Page Loads
    $('.accordion-container .accordion-header:first-of-type').toggleClass('active-header').toggleClass('inactive-header');
    $('.accordion-container .accordion-content:nth-of-type(2)').slideDown().toggleClass('open-content');

    // The Accordion Effect
    $('.accordion-header').click(function () {
      if ($(this).is('.inactive-header')) {
        $(this).siblings('.active-header').toggleClass('active-header').toggleClass('inactive-header').next().slideToggle().toggleClass('open-content');
        $(this).toggleClass('active-header').toggleClass('inactive-header');
        $(this).next().slideToggle().toggleClass('open-content');
      } else {
        $(this).toggleClass('active-header').toggleClass('inactive-header');
        $(this).next().slideToggle().toggleClass('open-content');
      }
    });
  }
}

// function console.log(status) {
//   console.log(status);
// }

function pageload(state) {
  if (state == 'show') {
    var loadingHtml = '<div class="page-loading"><div class="spin-icon"></div></div>';
    $(html.id).prepend(loadingHtml);
  } else if (state == 'hide') {
    var $loading = $('.page-loading');
    if ($loading.length) {
      $loading.remove();
    }
  }
}

function initiateCart1() {
  $.getJSON("/cart.js", function (e) {
    buildItemRows1(e);

    $('body').removeClass('empty-cart');
    $('body').addClass('slide-cart');
    
    // setTimeout((function () {
    //   $("body").removeClass("slide-cart")
    // }), 4e3);
    
    setTimeout((function () {
      //var c = $('.checkout-box .total-amount').text(' | $'+parseFloat(cart_obj.items_subtotal_price / 100).toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      var hiddenPrice = $(".checkout-box #hidden-price").text();
      var hiddenShipping = $(".checkout-box #hidden-shipping").text();

      if(hiddenPrice > hiddenShipping){
        $("#theFreeShippingText").text("Your order is eligible for free shipping.");
      }
      console.log("hiddenPrice: "+ hiddenPrice);
      console.log("hiddenShipping: "+ hiddenShipping);
    }), 500);

    updateCartTotal1(e);

  });

  function buildItemRows1(t) {
    //console.log("t is: "+JSON.stringify(t));

    $(".cart-toggle .cart-item-count").text(t.item_count);
    $(".cart-drawer .total-cart").text(t.item_count);

    if (t.item_count > 1) {
      $('.cart-drawer .item-title').text("Items");
    } else {
      $('.cart-drawer .item-title').text("Item");
    }
    // Update subtotal
    var subtotalPrice = parseFloat(t.items_subtotal_price / 100);
    $(".checkout-box .subtotal-amount").text("$" + subtotalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    
    // Calculate savings using TRUE original price (handles all discount types)
    var totalSavings = 0;
    var totalOriginalPrice = 0;
    t.items.forEach(function(item) {
      // Determine TRUE original price (before all discounts)
      var trueOriginalPrice;
      if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
        // Has subscription - use selling_plan's compare_at_price as the true original
        trueOriginalPrice = item.selling_plan_allocation.compare_at_price * item.quantity;
      } else if (item.compare_at_price) {
        // Has product-level discount - use compare_at_price
        trueOriginalPrice = item.compare_at_price * item.quantity;
      } else {
        // No product discount - use original_price
        trueOriginalPrice = item.original_price * item.quantity;
      }
      
      var itemFinalPrice = item.final_line_price; // in cents
      var itemSavings = trueOriginalPrice - itemFinalPrice;
      
      totalOriginalPrice += trueOriginalPrice;
      
      if (itemSavings > 0) {
        totalSavings += itemSavings;
      }
    });
    
    // Convert from cents to dollars
    totalSavings = totalSavings / 100;
    totalOriginalPrice = totalOriginalPrice / 100;
    
    if (totalSavings > 0.01) {
      $(".checkout-box .savings-amount").text("$" + totalSavings.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      $(".checkout-box .cart-savings").attr('style', 'display: flex !important').show();
      
      // Update original price in subtotal
      $(".checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price")
        .text("$" + totalOriginalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))
        .attr('style', 'display: inline !important')
        .show();
    } else {
      $(".checkout-box .cart-savings").attr('style', 'display: none !important');
      $(".checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price").attr('style', 'display: none !important');
    }

    $('.cart-drawer .cart-items').empty();

    t.items.forEach(function (item) {
      // console.log("'items: "+JSON.stringify(item.line_level_discount_allocations));
      // console.log("'items size: "+item.line_level_discount_allocations.size);
      var lineItem = $('.drawer-row-item[data-productid="' + item.id + '"][data-product-properties="' + item.properties['Quiz Result'] + '"]');
      
      if (lineItem.length > 0) {
        $("[id='updates_" + item.key + "'").val(item.quantity);
        var o = parseFloat(item.line_price / 100);
        lineItem.find(".item-total").text("$" + o.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      } else {
        //if (item.properties['Quiz Result']) {
          var i = "";
          o = parseFloat(item.line_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
          c = parseFloat(item.original_line_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
          
          i += '<div class="drawer-row-item" data-lineitem-key="' + item.key + '" data-productid="' + item.id + '" data-product-properties="' + item.properties['Quiz Result'] + '" data-price="' + item.price + '"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="row no-gutters"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="col-4 cart-item--thumb"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="grid-item grid-thumb"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="product-thumbnail"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="product-image align-middle"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <a href="' + item.url + '"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <canvas width="114" height="125" style="background-image: url(' + item.featured_image.url.replace(/(\.[^\.]+)$/, '_120x$1') + ');" class="canvas-image heightbase"></canvas> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t </a> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="col-8 cart-item--description"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="grid-item grid-desc grid-x"> \n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="product-details" style="width: 90%;">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<a href="' + item.url + '">' + item.title + '</a>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div class="grid-item grid-price-remove"> <div class="d-flex align-items-end cart-item--bottom"> <div class="quantity-wrapper">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class="btn-quantity-control btn-reduce-quantity drawer-reduce">–</span><input type="number" name="updates[]" id="updates_' + item.key + '" value="' + item.quantity + '" min="0" aria-label="Item quantity" class="input-quantity"/><span class="btn-quantity-control btn-add-quantity drawer-add">+</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t <div style="display: flex;justify-content: flex-start;align-items: center;width: 45%;"><span class="btn-remove-item item-remove ajax-remove-lineitem" data-id="' + item.id + '" data-price="'+ item.price+'" style="font-size:12px;">Remove</span></div><div class="cart-price--wrapper text-right"> <div class="item-total">$' + o + '</div>';
          if(o != c){
            i += '<div class="item-disc discountedPrice text-right"><s style="color: #909090;">'+ c +' </s></div>';
          }
          i += '</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t </div></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t </div>';

          jQuery.each(item.line_level_discount_allocations, function(x, y) {
            console.log("discount: "+y.discount_application.title);
            i += '<div class="col-12 cart-item--description"><div class="grid-item pt-4"><div class="item-giftNote note-discount text-right">'+y.discount_application.title+'</div></div></div>';
          });
         
          i += '\n\t\t\t\t\t\t\t\t\t\t\t\t\t </div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>';
          //$(".cart-drawer .cart-items").prepend(i);
          $('.cart-drawer .cart-items').append(i);
         
        //}

        
      }
    });
    checkBundleinCart(t);
  }

  function updateCartTotal1(e) {
    console.log("update cart");
    var o = parseFloat(e.total_price / 100),
      i = e.item_count;
    i > 0 ? $("body").removeClass("empty-cart") : $("body").addClass("empty-cart"), $(".cart-toggle .cart-item-count").text(i), $(".cart-total-wrapper .cart-total-amount").text("$" + o.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    
    $("#hidden-price").text(o);
    updateCartDrawerTotal1(e);
  };

  function updateCartDrawerTotal1(t) {
    var e = parseFloat(t.total_price / 100),
      o = t.item_count;
    
    // Update subtotal
    $(".cart-drawer .checkout-box .subtotal-amount").text("$" + e.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
    $(".cart-drawer .total-cart").text(o);
    
    // Calculate savings using TRUE original price (handles all discount types)
    var totalSavings = 0;
    var totalOriginalPrice = 0;
    t.items.forEach(function(item) {
      // Determine TRUE original price (before all discounts)
      var trueOriginalPrice;
      if (item.selling_plan_allocation && item.selling_plan_allocation.compare_at_price) {
        // Has subscription - use selling_plan's compare_at_price as the true original
        trueOriginalPrice = item.selling_plan_allocation.compare_at_price * item.quantity;
      } else if (item.compare_at_price) {
        // Has product-level discount - use compare_at_price
        trueOriginalPrice = item.compare_at_price * item.quantity;
      } else {
        // No product discount - use original_price
        trueOriginalPrice = item.original_price * item.quantity;
      }
      
      var itemFinalPrice = item.final_line_price; // in cents
      var itemSavings = trueOriginalPrice - itemFinalPrice;
      
      totalOriginalPrice += trueOriginalPrice;
      
      if (itemSavings > 0) {
        totalSavings += itemSavings;
      }
    });
    
    // Convert from cents to dollars
    totalSavings = totalSavings / 100;
    totalOriginalPrice = totalOriginalPrice / 100;
    
    if (totalSavings > 0.01) {
      $(".cart-drawer .checkout-box .savings-amount").text("$" + totalSavings.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      $(".cart-drawer .checkout-box .cart-savings").attr('style', 'display: flex !important').show();
      
      // Update original price in subtotal
      $(".cart-drawer .checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price")
        .text("$" + totalOriginalPrice.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"))
        .attr('style', 'display: inline !important')
        .show();
    } else {
      $(".cart-drawer .checkout-box .cart-savings").attr('style', 'display: none !important');
      $(".cart-drawer .checkout-box .subtotal-price-wrapper .subtotal-undiscounte-price").attr('style', 'display: none !important');
    }
    
    if (e.toFixed(2) == 0) {
      $(".cart-drawer .total-cart").text("");
      $(".cart-drawer .checkout-box .subtotal-amount").text("");
      $(".cart-drawer .checkout-box .cart-savings").hide();
    }
    
    $(".cart-total-wrapper .cart-total-amount").text("$" + e.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
  }

  function checkBundleinCart(cart) {
    var cart_line_item = cart.items;
    var bundle_in_cart = [];
    cart_line_item.forEach(function (item) {
      var product_id = item.id;
      var item_prop_obj = item.properties;
      for (var key in item_prop_obj) {
        if (key == 'Quiz Result') {
          console.log(product_id)
          $('button.add-to-cart-btn[data-variant-id="' + product_id + '"]').addClass('disabled');
          $('button.add-to-cart-btn[data-variant-id="' + product_id + '"]').html('Item Added to Cart');

          bundle_in_cart.push('' + product_id + '');
        }

      }
    });

    // compare arrays:
    var isIdentical = function (arr1, arr2) {
      return $(arr1).not(arr2).length === 0 && $(arr2).not(arr1).length === 0;
    }

    // get comparison result:
    var result = isIdentical(bundle_in_cart, bundleID)

    if (result) {
      $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').text('Your Bundle is Already In The Cart');
      $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').addClass('disabled');
    } else {
      $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').removeClass('disabled');

      var get_origtex = $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').attr('data-origtext');
      if (get_origtex) {
        $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').html(get_origtex);
      }

    }
  }

}

function checkCart() {
  var original_text = $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').html();
  $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').attr('data-origtext', original_text);

  $.getJSON('/cart.js', function (cart) {
    var cart_line_item = cart.items;
    var bundle_in_cart = [];
    cart_line_item.forEach(function (item) {
      var product_id = item.id;
      var item_prop_obj = item.properties;
      for (var key in item_prop_obj) {
        if (key == 'Quiz Result') {
          console.log(product_id)
          $('button.add-to-cart-btn[data-variant-id="' + product_id + '"]').addClass('disabled');
          $('button.add-to-cart-btn[data-variant-id="' + product_id + '"]').html('Item Added to Cart');

          bundle_in_cart.push('' + product_id + '');
        }

      }
    });

    // compare arrays:
    var isIdentical = function (arr1, arr2) {
      return $(arr1).not(arr2).length === 0 && $(arr2).not(arr1).length === 0;
    }

    // get comparison result:
    var result = isIdentical(bundle_in_cart, bundleID)

    if (result) {
      $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').text('Your Bundle is Already In The Cart');
      $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').addClass('disabled');
    } else {
      $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').removeClass('disabled');
      var get_origtex = $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').attr('data-origtext');
      if (get_origtex) {
        $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').html(get_origtex);
      }
    }
  });


  $(document).on('click', '.ajax-remove-lineitem', function (e) {
    var id = $(this).data('id');
    var item_price = $(this).data('price');
    var price = '$' + parseFloat(item_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    $('button.add-to-cart-btn[data-variant-id="' + id + '"]').removeClass('disabled');
    // button with price
    $('.description button.add-to-cart-btn[data-variant-id="' + id + '"]').html('Add to Cart<span>|</span><span class="add-to-cart-btn-price">' + price + '</span>');
    $('.tbc-content__secondary button.add-to-cart-btn[data-variant-id="' + id + '"]').html('Add to Cart');

    setTimeout((function () {
      var priceInt = $(".checkout-box #hidden-price").text();
      
      //var c = $(".checkout-box .total-amount").text(" | $" + parseFloat(t.items_subtotal_price / 100).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,"));
      if(priceInt == 0){
        $('body').addClass('empty-cart');
      }
      if ($(".item-giftNote")[0]){}else{
        $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').removeClass('disabled');
        var get_origtex = $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').attr('data-origtext');
        if (get_origtex) {
          $('#beautyChef_questionnaire .recommendation-body .tbc-content__bundle .bundle-to-cart-btn').html(get_origtex);
        }
      }
    }), 2000);
    
  });
}

